import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import Constants from 'expo-constants'
import {
    Text,
    Image,
    View,
    FlatList,
    TouchableOpacity,
    Dimensions,
    Alert,
    StatusBar,
    Linking,
    PixelRatio,
    ActivityIndicator,
    Animated,
} from 'react-native'
import { FlashList } from '@shopify/flash-list'
import NetInfo from '@react-native-community/netinfo'
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    DataSheetModel,
    FormsModel,
    KpisIndicators,
    PerfectStoreModel,
    StoreAdditionalInfo,
    StoreDetailModel,
} from './models/StoreDetailModel'
import { BenefitItemModel } from '../benefits/models/BenefitItemModel'
import styles from './StoreDetailStyles'
import stylesSchedules from './ScheduleStyles'
import stylesCampaingView from './CampaignViewStyles'
import stylesScheduleDistributor from './ScheduleDistributorStyles'
import { openDB } from '../../db/indexDB'
import { EvilIcons, Feather, Ionicons } from '@expo/vector-icons'
import { getForms, getStores } from '../../db/posSchedules'
import { FormView } from './ExecutionView'
import { useNavigation, useFocusEffect } from '@react-navigation/native'
import * as Progress from 'react-native-progress'
import { placeholderGeneral } from '../customUtils/Constants'
import { LinearGradient } from 'expo-linear-gradient'
import theme from '../../../theme'
import { ScrollView } from 'react-native-gesture-handler'
import {
    request_checkin,
    request_checkout,
    request_get_store,
} from '../../services/schedule.services'
import { schedulesServices } from '../../../database/schedules.database'
import {
    addOrUpdateAdvanceSchedule,
    saveFormAnswers,
} from '../../../db-sqlite/repositories/schedule.repository'
import { getLocation } from '../appBar/context/LocationContext'
import {
    CONSTANTS_TYPES_STEPS,
    FORM_SCHEDULE_STATUS,
    FORM_TYPES,
    ID_DROPDOWN_USERS,
    STORE_STATUS,
} from './constants/constants.stores'
import {
    FormProps,
    useFormContext,
    useFormRefrigeratorContext,
} from './context/form.context'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FormSteps } from './FormSteps'
import { CampaignStatus } from './StatusTagsStores'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { useStoreContext } from './context/store.context'
import { ActivitysModel } from './models/ScheduleModel'
import { getDistanceWithTextCal } from '../customUtils/calculateDistance'
import { SecondaryActionFormUsers } from './interfaces/StoreDetail.interface'
import { getConection } from '../appBar/context/HeaderContext'
import { useModerationPeriodStore } from '../../redux/zustand/modarationPeriodStore'
import { useStoreStatusStore } from '../../redux/zustand/storesStatusStore'
import { useStoreKpisStore } from '../../redux/zustand/storeKpisStore'
import { useFormSendStatusStore } from '../../redux/zustand/formSendStatusStore'
import { StorageAdapter } from '../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from './constants/constants.storage'
import { StoreVouchersList } from './StoreVouchersList'
import {
    captureAndSaveDataError,
    generateDayUniqueId,
    hasShowProgress,
    isEntornoTesting,
    isValidMongoId,
    openExternalLink,
    validateConnectionNetwork,
    validateUpdateCoordsTime,
} from '../../utils/functions.utils'
import { useFormView } from './hooks/useFormView'
import { PATH_ASSETS, TRACKINGS_TYPES } from '../../utils/Constants'
import useImageLoader from '../../hooks/useImageLoader'
import { useStepsDistributor } from '../../redux/zustand/stepsDistributorStore'
import { RoundedTabs } from '../customUtils/LinealTabs'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useFormIncidenceStore } from '../../redux/zustand/formIncedenceStore'
import { useSpinAnimation } from '../../hooks/useSpinAnimation'
import { StoreKPIIndicators } from '../customUtils/Components/Indicator'
import { TrackingServices } from '../../../database/tracking.database'
import { platformSelect } from '../../utils/platformUtils'
import { AnimatedCircularProgress } from 'react-native-circular-progress'
import { STORE_VIEW_MAP } from './constants/constants.views'
import { storeDetailOrder } from '../../../themeConstants'
import { UserServices } from '../../../database/user.database'
import { CLIENTS } from '../../constants/clients'

interface Props extends StackScreenProps<DotsNavigation, 'StoreDetail'> {}

const { width } = Dimensions.get('window')

const CHECKIN_PENDIENTE = 0
const CHECKIN_REALIZADO = 1
const CHECKOUT_REALIZADO = 3

export const StoreDetail = React.memo(({ route }: Props) => {
    // console.log('me vuelvo a renderizar ?? StoreDetail')
    const {
        storeID,
        forms,
        scheduleID,
        steps,
        forms_relevant,
        forms_advances,
        distance,
        store_status,
        navigate_form,
        incidence_answer,
    } = route.params

    console.log('store_detail id => ', storeID, 'schedueleID => ', scheduleID)

    const expoConfig = Constants.expoConfig || { slug: '' }
    const fontScale = 1
    const iconSizeMin = 14 * fontScale

    const {
        formsContext,
        setFormsContext,
        setReloadChange,
        setCurrentCheckin,
        updateStatusForm,
        reload,
    } = useFormContext()
    const memorizedForms = useMemo(() => formsContext, [formsContext])
    const { sendForm } = useFormView({})
    const { updateStoreStatus, stores, reloadForms } = useStoreContext()
    const { mergeAndSetFormRefrigeratorsMain, set_forms_refrigerators } =
        useFormRefrigeratorContext()
    const { userLat, userLng, askAgain, lastUpdateCoorsUser, checkLocation } =
        getLocation()

    const { languageFile } = getLanguage()
    const { isConnected, hasInternet } = getConection()

    const [status_store, setStatus_store] = useState(store_status)
    const [buttonIncidenceText, setButtonIncidenceText] = useState<String | null>(
        incidence_answer,
    )
    const [checkInID, setCheckinID] = useState('')
    const [checkInIDLocal, setCheckinIDLocal] = useState('')
    const [vouchers, setVouchers] = useState<BenefitItemModel[]>([])
    const [store, setStoreInfo] = useState<DataSheetModel>()
    const [perfectStoreArray, setPFA] = useState<PerfectStoreModel[]>([])
    const [showMore, setShowMore] = useState(true)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [loading, setLoading] = useState(true)
    const [initialLoadComplete, setInitialLoadComplete] = useState(false) // para saber si terminó la carga inicial
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [statusCheckin, setStatusCheckin] = useState(0)
    const [isIncidenceReport, setIsIncidenceReport] = useState(
        [
            STORE_STATUS.INCIDENCE_REPORTED,
            STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE,
            STORE_STATUS.INCIDENCE_REPORTED_CLOSE,
        ].includes(store_status),
    )
    const [statusSteps, setStatusSteps] = useState(0)
    const [progressRelev, setProgressRelev] = useState(0)
    const [isLoadingPerfectStore, setIsLoadingPerfectStore] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [showIndicators, setShowIndicators] = useState(false)
    const [checkoutInProcess, setCheckoutInProcess] = useState(false)
    const [iconSize, setIconSize] = useState(20)
    const [loadingCheckin, setLoadingCheckin] = useState<boolean>(false)
    const [loadingCheckout, setLoadingCheckout] = useState<boolean>(false)
    const [loadingExecution, setLoadingExecution] = useState(false)
    const [validateCheckout, setValidateCheckout] = useState({
        isPosibleCheckout: false,
        messageValidateCheckout: '',
    })
    const [validateCheckin, setValidateCheckin] = useState({
        isPosibleCheckin: true,
        messageValidateCheckin: '',
    })
    const [startAnimationLoaderUbi, setStartAnimationLoaderUbi] = useState(false)

    const spinRefreshUbi = useSpinAnimation(startAnimationLoaderUbi)
    const isUserBlocked = useModerationPeriodStore((state) => state.isUserBlocked)
    const setStepsDistri = useStepsDistributor((state) => state.setSteps)
    const clearStepsDistributor = useStepsDistributor((state) => state.clearSteps)
    const setStoreStatus = useStoreStatusStore((state) => state.setStoreStatus)
    const latestKpisFromForms = useStoreKpisStore((state) => state.kpisMap[storeID])
    const sentFormsForStore = useFormSendStatusStore(
        (state) => state.sentFormsMap[storeID],
    )
    const canFormIncidence = useFormIncidenceStore((state) => state.canFormIncidence)
    const formIncidence = useFormIncidenceStore((state) => state.formIncidence)
    const clearDataFormIncidence = useFormIncidenceStore(
        (state) => state.clearDataFormIncidence,
    )

    // ✅ Ref para rastrear el storeID previo
    const prevStoreIdRef = useRef(storeID)

    // ✅ Ref para bloquear recarga de datos durante check-in
    const isUpdatingFormStatusRef = useRef(false)

    // ✅ Ref para controlar operaciones de BD y evitar "database is locked"
    const dbOperationInProgressRef = useRef(false)
    const dbOperationQueueRef = useRef<(() => Promise<void>)[]>([])

    const routes = useMemo(
        () => [
            { key: 'benefits', title: 'Beneficios' },
            { key: 'redimes', title: 'Historial' },
        ],
        [],
    )

    const [tabs, setTabs] = useState([
        {
            name: 'Vouchers',
            index: 0,
        },
        {
            name: 'Canjes',
            index: 1,
        },
    ])

    const fetchDataLocalNew = async () => {
        console.log(
            '🔍 [fetchDataLocalNew] INICIO - storeID:',
            storeID,
            'scheduleID:',
            scheduleID,
            'isUpdatingFormStatusRef:',
            isUpdatingFormStatusRef.current,
        )

        // ✅ Serializar fetch para evitar bloqueos de BD
        return executeDbOperation(async () => {
            try {
                // const database = await openDB()
                const findStoreContext = stores.find(
                    (store) => store._id === storeID,
                )
                const formularios = []
                let newForms = []
                try {
                    const details = await schedulesServices.getStore(storeID)
                    await setData({ data_sheet: details })

                    const savedKPIS = await schedulesServices.getStoreKPIS(storeID)
                    if (savedKPIS && savedKPIS.length > 0) {
                        // ✅ Ordenar KPIs con Perfect Store primero
                        const orderedKPIs = orderKPIsWithPerfectStoreFirst(savedKPIS)
                        setKpis(orderedKPIs)
                    }

                    const answers_response_moderation = []
                    const all_forms = []

                    newForms = [...newForms, ...forms]

                    if (newForms && newForms.length > 0) {
                        let forms_relevant: ActivitysModel[] = route.params.forms_relevant || []
                        let forms_featured: ActivitysModel[] = []

                        if (
                            findStoreContext &&
                            findStoreContext.forms_relevant
                        ) {
                            forms_relevant = findStoreContext.forms_relevant
                        }
                        if (
                            findStoreContext &&
                            findStoreContext.forms_featured
                        ) {
                            forms_featured = findStoreContext.forms_featured
                        }

                        try {
                            let status_store = await validateStatusCheckin()

                            console.log('newForms', newForms.length)
                            console.log(
                                '📊 [fetchDataLocalNew] status_store después de validateStatusCheckin:',
                                status_store,
                            )
                            for (const form_id of newForms) {
                                let answer_response = null
                                if (
                                    answers_response_moderation &&
                                    answers_response_moderation.length > 0
                                ) {
                                    const filteredForms =
                                        answers_response_moderation.filter(
                                            (form) =>
                                                form._id.toString() ===
                                                form_id.toString(),
                                        )
                                    if (filteredForms && filteredForms.length > 0) {
                                        answer_response = filteredForms.flatMap(
                                            (form) =>
                                                form.answers.map((answer) => ({
                                                    ...answer,
                                                    moderation: form.moderation,
                                                })),
                                        )
                                    }
                                }

                                try {
                                    const get_form = await schedulesServices.getForm(form_id)
                                    
                                    if (get_form && filterFormsByDate(get_form)) {
                                        if (
                                            get_form['type_form']['type'] ==
                                            FORM_TYPES.FORM_REDIRECT
                                        ) {
                                            //valido si tienen la key link valida
                                            let url = get_form?.link
                                            if (url && url != '') {
                                                const isValidUrl =
                                                    url &&
                                                    /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(
                                                        url,
                                                    )
                                                if (!isValidUrl) {
                                                    console.log(
                                                        'URL inválida o no disponible:',
                                                        url,
                                                    )
                                                    return
                                                }
                                            }
                                        }
                                        // console.log('status_store =>', status_store) // 1
                                        let status_form =
                                            status_store == CHECKIN_REALIZADO
                                                ? FORM_SCHEDULE_STATUS.PENDING
                                                : FORM_SCHEDULE_STATUS.BLOCKED
                                        // console.log('1 status_form => ', status_form) // 0
                                        let advance = null
                                        /*
                                        ✅ PRIORIDAD CORREGIDA:
                                        1. Primero buscar en BD local (tiene los datos MÁS ACTUALIZADOS del usuario)
                                        2. Solo si no existe en BD local, usar forms_advances como fallback
                                    */
                                        try {
                                            // ✅ PRIMERO: Buscar en BD local (SIEMPRE la fuente de verdad)
                                            let get_advance_local =
                                                await schedulesServices.getFormsAnswersInStore(
                                                    scheduleID,
                                                    form_id,
                                                    storeID,
                                                    null,
                                                    get_form?.repeat,
                                                )
                                            // let get_advance_local = await schedulesServices.getFormsAnswersInStore(scheduleID, form_id, storeID)

                                            if (
                                                get_advance_local &&
                                                get_advance_local.status !==
                                                    undefined
                                            ) {
                                                advance = get_advance_local
                                                // console.log(
                                                //     '✅ [fetchDataLocalNew] Usando datos de BD local:',
                                                //     {
                                                //         form_id,
                                                //         status: advance.status,
                                                //     },
                                                // )
                                            } else if (
                                                forms_advances &&
                                                forms_advances.length > 0
                                            ) {
                                                // ✅ FALLBACK: Solo usar forms_advances si NO hay datos en BD local
                                                const advanceFromParams =
                                                    forms_advances.find(
                                                        (form) =>
                                                            form._id == form_id,
                                                    )
                                                if (advanceFromParams) {
                                                    advance = advanceFromParams
                                                    console.log(
                                                        '⚠️ [fetchDataLocalNew] Usando datos de forms_advances (fallback):',
                                                        {
                                                            form_id,
                                                            status: advance.status,
                                                        },
                                                    )
                                                }
                                            }
                                        } catch (error) {
                                            console.error(
                                                '❌ [fetchDataLocalNew] Error en getFormsAnswersInStore:',
                                                error,
                                            )
                                            const dataCapture = {
                                                log: error,
                                                date: new Date().toISOString(),
                                                end: 'fetchDataLocalNew forof - getFormsAnswers',
                                                additional: JSON.stringify({
                                                    store_id: storeID,
                                                    schedule_id: scheduleID,
                                                    forms: forms,
                                                    form_id: form_id,
                                                    formsContext: formsContext,
                                                }),
                                            }
                                            captureAndSaveDataError(dataCapture)
                                        }
                                        if (
                                            advance &&
                                            (status_store == CHECKIN_REALIZADO ||
                                                status_store == CHECKOUT_REALIZADO ||
                                                status_store ==
                                                    CampaignStatus.STATUS_FORM_REFUSED)
                                        ) {
                                            // ✅ Aplicar status de BD local a TODOS los formularios (incluidas heladeras)
                                            get_form.progress_questions_yes_na =
                                                advance.progress !== ''
                                                    ? parseInt(advance.progress)
                                                    : 0
                                            status_form = advance.status
                                            // ✅ Para repeat=1: si ya existe un registro completado, mostrar visualmente según si ya se envió o no
                                            if (get_form.repeat === 1 && advance.hasCompletedRepeat) {
                                                status_form = advance.completedRepeatSent
                                                    ? FORM_SCHEDULE_STATUS.COMPLETED
                                                    : FORM_SCHEDULE_STATUS.IN_PROGRESS
                                                    // : FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                            }
                                            // console.log(
                                            //     '✅ [fetchDataLocalNew] Aplicando status de BD:',
                                            //     {
                                            //         form_id,
                                            //         status: status_form,
                                            //         name_form: get_form.name_form,
                                            //     },
                                            // )
                                            get_form.complete = true
                                            get_form.scoreObtained =
                                                advance.progress !== ''
                                                    ? parseInt(advance.progress)
                                                    : 0

                                            // ✅ FIX: Reconstruir estado de preguntas tipo 37 desde respuestas guardadas
                                            if (
                                                advance.answers &&
                                                advance.answers.length > 0 &&
                                                get_form.contents &&
                                                get_form.type_form?.type ===
                                                    FORM_TYPES.FORM_POP_HELADERA
                                            ) {
                                                console.log(
                                                    `🔧 [fetchDataLocalNew] Reconstruyendo estado de ${advance.answers.length} preguntas tipo 37 desde BD`,
                                                )

                                                // Crear mapa de respuestas por question_id para búsqueda rápida
                                                const answersMap = new Map()
                                                advance.answers.forEach((answer) => {
                                                    if (
                                                        answer.question_id ||
                                                        answer._id
                                                    ) {
                                                        answersMap.set(
                                                            answer.question_id ||
                                                                answer._id,
                                                            answer,
                                                        )
                                                    }
                                                })

                                                // Actualizar estado de cada pregunta según sus respuestas
                                                get_form.contents =
                                                    get_form.contents.map(
                                                        (content) => {
                                                            const savedAnswer =
                                                                answersMap.get(
                                                                    content._id,
                                                                )
                                                            if (savedAnswer) {
                                                                console.log(
                                                                    `  ✅ Pregunta ${content._id}: active=false, index=${savedAnswer.index}`,
                                                                )
                                                                return {
                                                                    ...content,
                                                                    active: false,
                                                                    index:
                                                                        savedAnswer.index !==
                                                                        undefined
                                                                            ? savedAnswer.index
                                                                            : 0,
                                                                }
                                                            }
                                                            return content
                                                        },
                                                    )
                                            }
                                        }

                                        // ✅ Validación defensiva: asegurar que contents existe y es un array
                                        if (
                                            !get_form.contents ||
                                            !Array.isArray(get_form.contents)
                                        ) {
                                            console.warn(
                                                `⚠️ StoreDetail: get_form.contents es null o inválido para form_id: ${form_id}`,
                                            )
                                            get_form.contents = []
                                        }

                                        const questions = get_form.contents.map(
                                            (question) => {
                                                return {
                                                    _id: question._id,
                                                    title: question.title,
                                                    ponderar:
                                                        question.questionScore &&
                                                        question.questionScore > 0, //[7, 8, 14, 18].includes(question.input_type.type),
                                                    questionScore:
                                                        question.questionScore,
                                                    input_type: question.input_type,
                                                    secondary_actions:
                                                        question.secondary_actions,
                                                    mandatory: question.mandatory,
                                                    score: question.score,
                                                    description: question.description
                                                }
                                            },
                                        )

                                        let form_save = {
                                            schedule_id: scheduleID,
                                            form_id: form_id,
                                            store_id: storeID,
                                            repeat: get_form.repeat,
                                            questions:
                                                JSON.stringify(questions) ?? '[]',
                                            progress: get_form.progress,
                                            totalScore: get_form.totalScore,
                                            status: status_form,
                                            scoreObtained:
                                                get_form?.scoreObtained || 0,
                                            progress_questions_yes_na:
                                                get_form.progress_questions_yes_na ||
                                                0,
                                            answers: '[]',
                                            name_form: get_form.name_form,
                                            heladera: get_form.heladera,
                                            create_refrigerator:
                                                get_form.create_refrigerator,
                                            type_form: get_form.type_form,
                                            form_id_father: get_form.form_id_father,
                                            checkout: true,
                                            link: get_form.link,
                                            checkin_id: Date.now().toString(),
                                        }

                                        if (
                                            answer_response &&
                                            answer_response.length > 0
                                        ) {
                                            form_save.answers =
                                                JSON.stringify(answer_response)
                                        }

                                        // ✅ Usar retry logic para evitar "database is locked"
                                        const saveFormResponse =
                                            await retryDbOperation(async () => {
                                                return await saveFormAnswers(
                                                    form_save,
                                                )
                                            })

                                        let statusForm =
                                            saveFormResponse?.result?.status
                                        const scoreObtained =
                                            saveFormResponse?.result?.scoreObtained
                                        const cant_questions_yes_na =
                                            saveFormResponse?.result
                                                ?.cant_questions_yes_na
                                        const progress =
                                            saveFormResponse?.result?.progress === 1
                                                ? true
                                                : false
                                        const progress_questions_yes_na =
                                            saveFormResponse?.result
                                                ?.progress_questions_yes_na
                                        const form_id_fqa =
                                            saveFormResponse?.result?._id

                                        if (
                                            status_form ===
                                                FORM_SCHEDULE_STATUS.BLOCKED &&
                                            status_store === CHECKIN_REALIZADO
                                        ) {
                                            status_form =
                                                FORM_SCHEDULE_STATUS.PENDING
                                        }

                                        formularios.push({
                                            ...get_form,
                                            store_id: storeID,
                                            schedule_id: scheduleID,
                                            status: status_form,
                                            scoreObtained: scoreObtained,
                                            progress: progress,
                                            cant_questions_yes_na:
                                                cant_questions_yes_na,
                                            progress_questions_yes_na:
                                                progress_questions_yes_na,
                                            mandatory: forms_relevant.some(
                                                (form) => form?._id == form_id,
                                            ),
                                            featured: forms_featured.some(
                                                (form) => form?._id == form_id,
                                            ),
                                            form_id_fqa: form_id_fqa,
                                        })
                                    }
                                } catch (error) {
                                    console.error(
                                        `144:   getForm: ${form_id}`,
                                        error,
                                    )
                                    const dataCapture = {
                                        log: error,
                                        date: new Date().toISOString(),
                                        end: 'fetchDataLocalNew forof',
                                        additional: JSON.stringify({
                                            store_id: storeID,
                                            schedule_id: scheduleID,
                                            forms: forms,
                                            form_id: form_id,
                                            formsContext: formsContext,
                                        }),
                                    }
                                    captureAndSaveDataError(dataCapture)
                                }

                                // ✅ Pequeño delay para reducir presión sobre SQLite
                                if (newForms.length > 5) {
                                    await new Promise((resolve) =>
                                        setTimeout(resolve, 10),
                                    )
                                }
                            }
                        } catch (error) {
                            const dataCapture = {
                                log: error,
                                date: new Date().toISOString(),
                                end: 'fetchDataLocalNew1',
                                additional: JSON.stringify({
                                    store_id: storeID,
                                    schedule_id: scheduleID,
                                    forms: forms,
                                    formsContext: formsContext,
                                }),
                            }
                            captureAndSaveDataError(dataCapture)
                        } finally {
                            formularios.sort((a, b) => a.index_form - b.index_form)
                            verifyShowLoaderExecution(formularios)
                            setFormsContext(formularios)
                        }
                    }
                } catch (error) {
                    console.error(' ~0 fetchData store ~ error:', error)
                    const dataCapture = {
                        log: error.message,
                        date: new Date().toISOString(),
                        end: 'fetchDataLocalNew2',
                        additional: JSON.stringify({
                            store_id: storeID,
                            schedule_id: scheduleID,
                            forms: forms,
                            formsContext: formsContext,
                        }),
                    }
                    captureAndSaveDataError(dataCapture)
                } //sin conexion
            } catch (error) {
                console.error('Error en fetchDataNew:', error)

                const dataCapture = {
                    log: error.message,
                    date: new Date().toISOString(),
                    end: 'fetchDataLocalNew3',
                    additional: JSON.stringify({
                        store_id: storeID,
                        schedule_id: scheduleID,
                        forms: forms,
                        formsContext: formsContext,
                    }),
                }
                captureAndSaveDataError(dataCapture)
            }
        }) // Cerrar executeDbOperation
    }

    /**
     * ✅ Maneja la carga completa de datos (local + online)
     */
    const loadAllData = async () => {
        try {
            setLoading(true)
            setInitialLoadComplete(false)

            // 1. Cargar datos locales primero
            await fetchDataLocalNew()

            // 2. Cargar datos online y ESPERAR a que termine completamente
            // Esto asegura que Perfect Store y otros datos estén procesados
            // antes de marcar la carga como completa
            await fetchDataOnlineNew()

            // 3. Delay para permitir que React procese todos los setState
            // antes de mostrar las secciones Perfect Store y Ejecución
            setTimeout(() => {
                console.log('✅ [loadAllData] Marcando carga inicial como completa')
                setLoading(false)
                setInitialLoadComplete(true)
            }, 200)
        } catch (error) {
            console.error('❌ [loadAllData] Error:', error)
            setLoading(false)
            setInitialLoadComplete(true)
        }
    }

    const verifyShowLoaderExecution = async (formularios) => {
        try {
            const questDropdowsn = []
            formularios.forEach((form) => {
                const questions = form.contents
                if (questions && questions.length > 0) {
                    for (const quest of questions) {
                        if (
                            quest.input_type &&
                            quest.input_type._id === ID_DROPDOWN_USERS
                        ) {
                            questDropdowsn.push(quest)
                            break
                        }
                    }
                }
            })
            if (questDropdowsn.length > 0) {
                setLoadingExecution(true)
            }
        } catch (error) {
            console.error('Error en verifyShowLoaderExecution:', error)
        }
    }

    const fetchDataOnlineNew = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()
            const { existsInDB, _id_mongoDB } =
                await schedulesServices.getExistsInDB(storeID)

            if (hasConnection && existsInDB) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''
                // console.log('_id_mongoDB: ', _id_mongoDB, 'storeID: ', storeID, 'scheduleID: ', scheduleID)
                const response = await request_get_store({
                    authToken,
                    store_id: _id_mongoDB ? _id_mongoDB : storeID,
                    schedule_id: scheduleID,
                })

                // console.log('📡📡📡📡📡 [fetchDataOnlineNew] Response del servidor:', JSON.stringify(response)) // Log completo de la respuesta

                if (response && response.status && response.response.status == 1) {
                    let data = response.response
                    // console.log('data => ', JSON.stringify(data))
                    if (data && data.status == 1 && data.single) {
                        // agrego users en el form, actualizo
                        if (
                            data.single.forms_users &&
                            data.single.forms_users.length > 0
                        ) {
                            await agregateUsersFormDropdown(data.single.forms_users)
                        }
                        // Si ya pasó la carga inicial, actualizar sin mostrar loaders
                        if (initialLoadComplete) {
                            await setData(data.single)
                            // NO mostrar loaders en actualizaciones posteriores
                        } else {
                            // Primera carga: setData maneja sus propios loaders internamente
                            // NO forzar loaders a false aquí, dejar que setData() controle su estado
                            await setData(data.single)
                        }
                    }
                }
            } else {
                setLoadingExecution(false)
                setIsLoadingPerfectStore(false)
            }
        } catch (error) {
            console.error('Error en fetchDataOnlineNew:', error)
            // Asegurar que el loading se resetea incluso si hay un error
            setLoadingExecution(false)
            setIsLoadingPerfectStore(false)
        } finally {
            console.log('[fetchDataOnlineNew] FIN - Datos online procesados')
        }
    }

    const loadData = async () => {
        await validateStatusCheckin()
        await calculateRelevProgress()
    }

    const filterFormsByDate = (form): boolean => {
        try {
            let filter = false

            const currentDate = new Date()

            const questions = form.contents
            const formStartEjecution = form.start_ejecution ?? null
            const formEndEjecution = form.end_ejecution ?? null

            if (formStartEjecution && formEndEjecution) {
                const startEjecution = new Date(formStartEjecution)
                const endEjecution = new Date(formEndEjecution)
                return startEjecution <= currentDate && endEjecution >= currentDate
            }

            if (questions && questions.length > 0) {
                for (const quest of questions) {
                    const questStartEjecution = quest.start_ejecution ?? null // start_ejecution
                    const questEndEjecution = quest.end_ejecution ?? null // end_ejecution

                    if (questStartEjecution && questEndEjecution) {
                        const startEjecution = new Date(quest.start_ejecution)
                        const endEjecution = new Date(quest.end_ejecution)

                        const boolean =
                            startEjecution <= currentDate &&
                            endEjecution >= currentDate

                        if (boolean) {
                            filter = boolean
                            break
                        }
                    }
                }
            }

            return filter
        } catch (error) {
            console.error('Error en filterFormsByDate:', error)
            const dataCapture = {
                log: error.message,
                date: new Date().toISOString(),
                end: 'filterFormsByDate',
                additional: JSON.stringify({
                    store_id: storeID,
                    schedule_id: scheduleID,
                    forms: forms,
                    form_id: form._id,
                    formsContext: formsContext,
                }),
            }
            captureAndSaveDataError(dataCapture)

            return false
        }
    }

    /**
     *
     * @param arrayFormsPos data.single.forms_pos
     */
    const saveFormsHeladeras = async (arrayFormsPos) => {
        console.log('121 -- saveFormsHeladerassaveFormsHeladerassaveFormsHeladeras')

        const forms_ids_heladeras = []

        const forms_refrigerators = [] // los forms dentro de forms padres
        const form_refrigerators_main = [] // forms padres

        if (arrayFormsPos && arrayFormsPos.length > 0) {
            for (const form of arrayFormsPos) {
                const form_id_father = form._id

                try {
                    await schedulesServices.addForm(form, false, true)
                    forms_ids_heladeras.push(form._id)
                } catch (error) {
                    console.error(
                        '❌ [saveFormsHeladeras] Error guardando form padre:',
                        {
                            form_id: form._id,
                            error: error.message,
                        },
                    )
                    // Continuar con el siguiente formulario
                    continue
                }

                if (form.contents && form.contents.length > 0) {
                    for (const content of form.contents) {
                        // content.active = true // me viene del servicio ya
                        if (
                            content.secondary_actions &&
                            content.secondary_actions.length > 0 &&
                            content.secondary_actions.some(
                                (action) => action.form && action.form.length > 0,
                            )
                        ) {
                            for (const action of content.secondary_actions) {
                                if (
                                    action &&
                                    action.form &&
                                    action.form.length > 0
                                ) {
                                    let create_refrigerator = false
                                    if (
                                        content.input_type &&
                                        content.input_type &&
                                        content.input_type.type === 16
                                    ) {
                                        create_refrigerator = true
                                    }

                                    try {
                                        await schedulesServices.addForm(
                                            action.form[0],
                                            false,
                                            true,
                                            create_refrigerator,
                                            form_id_father,
                                        )
                                        let form = action.form[0]
                                        form.form_id_father = form_id_father
                                        form.question_id = content._id
                                        forms_refrigerators.push(form)
                                        forms_ids_heladeras.push(
                                            action.form[0]['_id'],
                                        )
                                    } catch (error) {
                                        console.error(
                                            '❌ [saveFormsHeladeras] Error guardando form hijo:',
                                            {
                                                form_id: action.form[0]._id,
                                                parent: form_id_father,
                                                error: error.message,
                                            },
                                        )
                                        // Continuar con el siguiente action
                                    }
                                }
                            }
                        }
                    }

                    form_refrigerators_main.push(form)
                }
            }
        }

        // ✅ FIX: Reconstruir estado de preguntas tipo 37 ANTES de hacer merge
        // Esto asegura que form_refrigerators_main tenga el estado correcto de active/index
        for (const form of form_refrigerators_main) {
            if (
                form.type_form?.type === FORM_TYPES.FORM_POP_HELADERA &&
                form.contents
            ) {
                try {
                    // Obtener respuestas guardadas de BD
                    const advance = await schedulesServices.getFormsAnswersInStore(
                        scheduleID,
                        form._id,
                        storeID,
                        null,
                        form.repeat,
                    )

                    if (advance && advance.answers && advance.answers.length > 0) {
                        console.log(
                            `🔧 [saveFormsHeladeras] Reconstruyendo estado de ${advance.answers.length} preguntas tipo 37 para form ${form._id}`,
                        )

                        // Crear mapa de respuestas por question_id
                        const answersMap = new Map()
                        advance.answers.forEach((answer) => {
                            if (answer.question_id || answer._id) {
                                answersMap.set(
                                    answer.question_id || answer._id,
                                    answer,
                                )
                            }
                        })

                        // Reconstruir estado de cada pregunta
                        form.contents = form.contents.map((content) => {
                            const savedAnswer = answersMap.get(content._id)
                            if (savedAnswer) {
                                console.log(
                                    `  ✅ Pregunta ${content._id}: active=false, index=${savedAnswer.index}`,
                                )
                                return {
                                    ...content,
                                    active: false,
                                    index:
                                        savedAnswer.index !== undefined
                                            ? savedAnswer.index
                                            : 0,
                                }
                            }
                            return content
                        })
                    }
                } catch (error) {
                    console.error(
                        `❌ [saveFormsHeladeras] Error reconstruyendo estado para ${form._id}:`,
                        error,
                    )
                }
            }
        }

        if (forms_ids_heladeras && forms_ids_heladeras.length > 0) {
            // ✅ FIX: Iterar sobre forms_ids_heladeras en vez de forms
            for (const form_id of forms_ids_heladeras) {
                await schedulesServices
                    .getForm(form_id)
                    .then(async (get_form) => {
                        // ✅ Validación defensiva: verificar que get_form existe
                        if (!get_form) {
                            console.warn(
                                `⚠️ StoreDetail: getForm devolvió null para form_id: ${form_id}`,
                            )
                            return
                        }

                        // ✅ Validación defensiva: asegurar que contents existe y es un array
                        if (
                            !get_form.contents ||
                            !Array.isArray(get_form.contents)
                        ) {
                            console.warn(
                                `⚠️ StoreDetail: get_form.contents es null o inválido para form_id: ${form_id}`,
                            )
                            get_form.contents = []
                        }

                        const questions = get_form.contents.map((question) => {
                            return {
                                _id: question._id,
                                title: question.title,
                                ponderar:
                                    question.questionScore &&
                                    question.questionScore > 0, //[7, 8, 14, 18].includes(question.input_type.type),
                                questionScore: question.questionScore,
                                input_type: question.input_type,
                                secondary_actions: question.secondary_actions,
                                mandatory: question.mandatory,
                                score: question.score,
                            }
                        })

                        const form_save = {
                            schedule_id: scheduleID,
                            form_id: form_id,
                            store_id: storeID,
                            repeat: get_form.repeat,
                            questions: JSON.stringify(questions) ?? '[]',
                            progress: get_form.progress,
                            totalScore: get_form.totalScore,
                            name_form: get_form.name_form,
                            heladera: get_form.heladera,
                            create_refrigerator: get_form.create_refrigerator,
                            type_form: get_form.type_form,
                            form_id_father: get_form.form_id_father,
                        }

                        // ✅ Usar retry logic para evitar "database is locked"
                        const saveFormResponse = await retryDbOperation(async () => {
                            return await saveFormAnswers(form_save)
                        })
                    })
                    .catch((error) =>
                        console.error(`290:   getForm: ${form_id} - `, error),
                    )
            }
        }

        set_forms_refrigerators(forms_refrigerators)
        mergeAndSetFormRefrigeratorsMain(form_refrigerators_main)
    }

    const agregateUsersFormDropdown = async (
        arrayFormUsers: SecondaryActionFormUsers[],
    ) => {
        try {
            if (!arrayFormUsers || arrayFormUsers.length === 0) {
                console.log('no hay usuarios en el formulario')
                return
            }

            // ✅ Usar retry logic para evitar "database is locked"
            await retryDbOperation(async () => {
                await schedulesServices.updateFormsSecondaryActionUsersDropdown(
                    arrayFormUsers,
                    storeID,
                )
            })

            // ❌ COMENTADO: No recargar todo aquí para evitar bloqueos de BD y recargas innecesarias
            // El sistema ya recarga cuando es necesario a través de los useEffect
            // await fetchDataLocalNew()
            console.log(
                '✅ [agregateUsersFormDropdown] Usuarios actualizados sin recargar todo',
            )
        } catch (error) {
            console.error('Error en agregateUsersFormDropdown:', error)
        }
    }

    const validateStatusCheckOut = () => {
        setStatusCheckin(CHECKOUT_REALIZADO)
    }

    const validateStatusCheckin = async () => {
        try {
            let status = null
            //ahora en tomo el status de checkin y checkout de schedules_advance
            await schedulesServices
                .getStoreScheduleAdvances(scheduleID, storeID)
                .then((response) => {
                    if (response) {
                        //tiene avance

                        //valido fechaa
                        let fecha_hoy = new Date()
                        let offset = fecha_hoy.getTimezoneOffset()
                        // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
                        fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
                        let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

                        //console.log('Fecha de hoy (solo fecha):', fecha_hoy_str, new Date(fecha_hoy_str))

                        if (
                            new Date(response.date_init) < new Date(fecha_hoy_str) &&
                            response.status !=
                                CampaignStatus.STATUS_FORM_PENDING_MODERATION &&
                            response.status !=
                                CampaignStatus.STATUS_MODERATION_APPROVED
                        ) {
                            // console.log('-----------fecha de hoyyy222222 ~ fecha_hoy:', fecha_hoy)
                            response.status = null
                        }
                        // console.log('457 --- -----------response222222 ~ response:', response.status)
                        switch (response.status) {
                            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                                setStatusCheckin(CHECKIN_REALIZADO)
                                setCurrentCheckin(response?.checkin_id)
                                schedulesServices
                                    .get_checkin(storeID, scheduleID)
                                    .then((checkin) => {
                                        if (checkin) {
                                            const index = checkin.length - 1
                                            setCheckinIDLocal(checkin[index]._id)
                                            setCheckinID(checkin[index].checkin_id)
                                        } else {
                                            if (response?.checkin_id) {
                                                setCheckinID(response?.checkin_id)
                                            }
                                        }
                                    })
                                status = CHECKIN_REALIZADO
                                break
                            case CampaignStatus.STATUS_MODERATION_APPROVED:
                            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                            case CampaignStatus.STATUS_FORM_APPROVED:
                            case CampaignStatus.STATUS_FORM_PENDING_MODERATION:
                                setStatusCheckin(CHECKOUT_REALIZADO)
                                status = CHECKOUT_REALIZADO
                                break
                            case CampaignStatus.STATUS_FORM_REFUSED:
                                status = CampaignStatus.STATUS_FORM_REFUSED
                                break
                            default:
                                break
                        }
                    } else {
                        console.log('NO HAY AVANCESSS EN validateStatusCheckin')

                        //no hizo nada
                    }
                })
                .catch((error) => console.error(error))
            return status
        } catch (error) {
            console.error('validateStatusCheckin => ', error)
            throw new Error(error)
        }
    }

    const setDataPFA = async () => {
        try {
            // Si hay una descarga de Perfect Store en progreso, esperar para evitar "database is locked"
            try {
                let waitCount = 0
                const maxWait = 20 // 20 * 300ms = ~6s
                let downloadInProgress = await StorageAdapter.getItem(
                    ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES,
                )
                while (downloadInProgress === 'true' && waitCount < maxWait) {
                    console.log(
                        `[setDataPFA] Esperando a que termine la descarga PF... intento ${waitCount + 1}/${maxWait}`,
                    )
                    await new Promise((res) => setTimeout(res, 300))
                    waitCount++
                    downloadInProgress = await StorageAdapter.getItem(
                        ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES,
                    )
                }
                if (downloadInProgress === 'true') {
                    console.warn(
                        '[setDataPFA] La descarga PF sigue en progreso tras esperar, intentando lectura de todas formas',
                    )
                }
            } catch (err) {
                console.warn(
                    '[setDataPFA] Error comprobando flag de descarga PF:',
                    err,
                )
            }

            const forms =
                await schedulesServices.getPerfectStoreRelationByStore(storeID)

            // Instrumentation: log local PF forms and async storage flags to confirm download state
            try {
                console.log(
                    '[setDataPFA] perfect store local forms count =>',
                    forms ? forms.length : 0,
                )
                const downloadInProgressPerfectStore = await StorageAdapter.getItem(
                    ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES,
                )
                const isUserContentZip = await StorageAdapter.getItem(
                    ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP,
                )
                const psZipAllSaved = await StorageAdapter.getItem(
                    ASYNC_STORAGE_KEYS.PS_ZIP_ALL_SAVED,
                )
                console.log('[setDataPFA] ASYNC STORAGE]', {
                    DOWNLOAD_IN_PROGRESS_PERFECT_STORES:
                        downloadInProgressPerfectStore,
                    IS_USER_CONTENT_ZIP: isUserContentZip,
                    PS_ZIP_ALL_SAVED: psZipAllSaved,
                })
            } catch (err) {
                console.warn(
                    '[setDataPFA] Error leyendo AsyncStorage flags PF:',
                    err,
                )
            }

            // Siempre resetear el loading, independientemente si hay forms o no
            setIsLoadingPerfectStore(false)
            return forms
        } catch (error) {
            console.error('Error en setDataPFA:', error)
            // Asegurar que se resetea el loading incluso si hay un error
            setIsLoadingPerfectStore(false)
            return []
        }
    }

    const setData = async (data: StoreDetailModel) => {
        let newDistance = getDistanceWithTextCal(distance)
        setStoreInfo({
            ...data?.data_sheet,
            distance: newDistance,
        })
        if (
            data &&
            data.data_sheet &&
            data.data_sheet.kpis_indicators &&
            data.data_sheet.kpis_indicators.length > 0
        ) {

            // ✅ Ordenar KPIs con Perfect Store primero
            const orderedKPIs = orderKPIsWithPerfectStoreFirst(
                data.data_sheet.kpis_indicators,
            )
            setKpis(orderedKPIs)
            await schedulesServices.updateStoreKPIS(storeID, orderedKPIs)

        } else if (Array.isArray(data?.data_sheet?.kpis_indicators)) {
            // Solo limpiar KPIs cuando el servidor responde explícitamente con array vacío.
            // Si kpis_indicators es undefined (datos locales), no tocar los KPIs guardados.
            setKpis([])
            await schedulesServices.clearStoreKPIS(storeID)
        }
        //console.log('550 --- 🚀 ~ setData ~ data?.perfect_store', data)
        const all_forms = data?.forms_pos ?? []
        if (all_forms && all_forms.length > 0) {
            // all_forms.forEach((form) => {
            //     ;(form.status === FORM_SCHEDULE_STATUS.BLOCKED && statusCheckin === CHECKIN_REALIZADO
            //         ? (form.status = FORM_SCHEDULE_STATUS.PENDING)
            //         : (form.status = form.status),
            //         newForms.push(form._id))
            // })

            await saveFormsHeladeras(all_forms)

            console.log(
                '✅ [setData] Forms de heladeras procesados, ahora aplicando status de BD local si es necesario => ',
                all_forms,
            )
            // ✅ Replicar lógica de fetchDataLocalNew: obtener status de BD local para cada heladera
            const status_store = await validateStatusCheckin()
            console.log(
                '✅ [setData] Status del store para determinar status de heladeras:',
                status_store,
            )
            const heladerasWithStatus = await Promise.all(
                all_forms.map(async (formHeladera) => {
                    let status_form =
                        status_store == CHECKIN_REALIZADO
                            ? FORM_SCHEDULE_STATUS.PENDING
                            : FORM_SCHEDULE_STATUS.BLOCKED

                    try {
                        // Buscar advance en BD local (igual que fetchDataLocalNew)
                        const advance =
                            await schedulesServices.getFormsAnswersInStore(
                                scheduleID,
                                formHeladera._id,
                                storeID,
                                null,
                                formHeladera.repeat,
                            )

                        console.log(
                            `✅ [setData] Avance local para heladera ${formHeladera._id}:`,
                            advance,
                        )

                        // Aplicar la misma lógica de fetchDataLocalNew
                        if (
                            advance &&
                            (status_store == CHECKIN_REALIZADO ||
                                status_store == CHECKOUT_REALIZADO ||
                                status_store == CampaignStatus.STATUS_FORM_REFUSED)
                        ) {
                            status_form = advance.status
                            console.log(
                                '✅ [setData] Status de BD local para heladera:',
                                {
                                    form_id: formHeladera._id,
                                    status: status_form,
                                    name_form: formHeladera.name_form,
                                },
                            )

                            // ✅ FIX: Reconstruir estado de preguntas tipo 37 desde respuestas guardadas
                            if (
                                advance.answers &&
                                advance.answers.length > 0 &&
                                formHeladera.contents
                            ) {
                                console.log(
                                    `🔧 [setData] Reconstruyendo estado de ${advance.answers.length} preguntas tipo 37 desde BD`,
                                )

                                // Crear mapa de respuestas por question_id para búsqueda rápida
                                const answersMap = new Map()
                                advance.answers.forEach((answer) => {
                                    if (answer.question_id || answer._id) {
                                        answersMap.set(
                                            answer.question_id || answer._id,
                                            answer,
                                        )
                                    }
                                })

                                // Actualizar estado de cada pregunta según sus respuestas
                                formHeladera.contents = formHeladera.contents.map(
                                    (content) => {
                                        const savedAnswer = answersMap.get(
                                            content._id,
                                        )
                                        if (savedAnswer) {
                                            console.log(
                                                `  ✅ Pregunta ${content._id}: active=false, index=${savedAnswer.index}`,
                                            )
                                            return {
                                                ...content,
                                                active: false,
                                                index:
                                                    savedAnswer.index !== undefined
                                                        ? savedAnswer.index
                                                        : 0,
                                            }
                                        }
                                        return content
                                    },
                                )
                            }
                        }
                    } catch (error) {
                        console.error(
                            `❌ [setData] Error obteniendo status para heladera ${formHeladera._id}:`,
                            error,
                        )
                    }

                    return {
                        ...formHeladera,
                        status: status_form,
                    }
                }),
            )

            // Actualizar formsContext con contenidos Y status de BD local
            setFormsContext((prevFormsContext) => {
                const updatedContext = [...prevFormsContext]
                for (const formHeladera of heladerasWithStatus) {
                    const existingIndex = updatedContext.findIndex(
                        (f) => f._id === formHeladera._id,
                    )
                    if (existingIndex !== -1) {
                        // Actualizar contenidos Y status
                        updatedContext[existingIndex] = {
                            ...updatedContext[existingIndex],
                            contents: formHeladera.contents,
                            status: formHeladera.status,
                        }
                        console.log(
                            `✅ [setData] Actualizado heladera ${formHeladera._id} - status: ${formHeladera.status}`,
                        )
                    } else {
                        // Agregar con status de BD local
                        updatedContext.push({
                            ...formHeladera,
                            store_id: storeID,
                            schedule_id: scheduleID,
                        })
                        console.log(
                            `✅ [setData] Agregado heladera ${formHeladera._id} - status: ${formHeladera.status}`,
                        )
                    }
                }
                return updatedContext
            })
        }

        //* -- Perfect Store offline ?
        let formsPerfectStoreData = []
        let formsPerfectStoreLocal = await setDataPFA()

        // console.log(
        //     '556 - 🚀 ~ setData ~ formsPerfectStoreLocal:',
        //     formsPerfectStoreLocal.length,
        //     formsPerfectStoreLocal.map((item) => item._id),
        // )
        let formsPerfectStoreOnline = data?.perfect_store ?? []
        // console.log(
        //     '558 - 🚀 ~ setData ~ formsPerfectStoreOnline:',
        //     formsPerfectStoreOnline.length,
        //     formsPerfectStoreOnline.map((item) => item._id),
        // )

        if (formsPerfectStoreOnline && formsPerfectStoreOnline.length > 0) {
            // comparar ids en ambos
            // console.log('comparar ids en ambos')
            if (formsPerfectStoreLocal && formsPerfectStoreLocal.length > 0) {
                // console.log('563 -- tengo local')
                formsPerfectStoreData = formsPerfectStoreLocal
                let hasUpdatePerfecStore = false
                // tengo local entonces comparo
                // tengo que comparar entre ids de ambos

                for (const formOnline of formsPerfectStoreOnline) {
                    const formLocal = formsPerfectStoreLocal.find(
                        (form) => form._id.toString() === formOnline._id.toString(),
                    )
                    if (!formLocal) {
                        // no esta en local, lo agrego
                        formsPerfectStoreData.push(formOnline)
                        hasUpdatePerfecStore = true
                    }
                }

                if (hasUpdatePerfecStore) {
                    setIsLoadingPerfectStore(true)
                }
            } else {
                console.log('583 --- no tengo local, utilizo online')
                // no tengo local entonces utilizo online
                formsPerfectStoreData = formsPerfectStoreOnline
                setIsLoadingPerfectStore(true)
            }
        } else {
            // no tengo online, entonces utilizo local
            console.log('no tengo online, entonces utilizo local')

            // Si ya tenemos Perfect Store cargado en el estado Y no hay datos ni online ni locales,
            // NO sobrescribirlo con un array vacío (evita que fetches encolados reseteen los datos)
            if (
                perfectStoreArray.length > 0 &&
                (!formsPerfectStoreLocal || formsPerfectStoreLocal.length === 0)
            ) {
                console.log(
                    `⚠️ [setData] Protegiendo Perfect Store existente (${perfectStoreArray.length} items) - Ignorando sobrescritura vacía`,
                )
                formsPerfectStoreData = perfectStoreArray // Mantener datos actuales
            } else {
                formsPerfectStoreData = formsPerfectStoreLocal ?? []
            }

            // Si no hay datos online pero sí local, resetear loading
            setIsLoadingPerfectStore(false)
        }

        // Si no hay datos de Perfect Store en absoluto, resetear loading en lugar de iniciarlo
        if (
            (!formsPerfectStoreLocal || formsPerfectStoreLocal.length == 0) &&
            (!formsPerfectStoreOnline || formsPerfectStoreOnline.length == 0)
        ) {
            setIsLoadingPerfectStore(false)
        }

        if (
            formsPerfectStoreData &&
            formsPerfectStoreData.length > 0 &&
            data &&
            data?.perfect_store_fa
        ) {
            formsPerfectStoreData = [
                ...formsPerfectStoreData,
                ...data?.perfect_store_fa,
            ]
        }

        const formsPerfectStoredataFilter = filterObjetives(formsPerfectStoreData)

        const sortedPerfectStore = formsPerfectStoredataFilter.sort(
            (a, b) => (a.index ?? 0) - (b.index ?? 0),
        )

        // FIX: Usar forma funcional de setPFA para evitar stale closure.
        // Cuando fetchDataLocalNew encolado corre DESPUÉS de fetchDataOnlineNew,
        // el closure tiene perfectStoreArray=[] (viejo) aunque ya se haya seteado a 3 items.
        // La forma funcional siempre recibe el estado más reciente de React.
        setPFA((prev) => {
            if (sortedPerfectStore.length === 0 && prev.length > 0) {
                console.log(
                    `[setData] Perfect Store: protegiendo ${prev.length} items existentes (no sobrescribir con vacío)`,
                )
                return prev
            }
            return sortedPerfectStore
        })

        // Log para debug: verificar cuántos elementos de Perfect Store se establecieron
        console.log(
            `[setData] Perfect Store actualizado con ${formsPerfectStoredataFilter.length} items`,
        )

        // ✅ Desactivar loader de Perfect Store después de procesar los datos
        // Esto asegura que el loader no se quede activo indefinidamente
        setIsLoadingPerfectStore(false)

        setVouchers(data.vouchers ?? [])
        const updatedForms = data?.forms?.map((form) => {
            const updatedContents = form?.contents?.map((content) => {
                if (content.status === 3) {
                    return {
                        ...content,
                        hideQuestion: true,
                    }
                }
                return content
            })
            return {
                ...form,
                contents: updatedContents,
            }
        })
        // setForms((prevStore) => [...prevStore, ...updatedForms])
        if (updatedForms && updatedForms.length > 0) {
            setFormsContext((prevStore) => [...prevStore, ...updatedForms])
        }

        //setForms(updatedForms ?? [])
        console.log('[setData] FIN - Procesamiento de datos completado')
    }

    const filterObjetives = (formsPerfectStoredata) => {
        const currentDate = new Date()

        let filter_forms = formsPerfectStoredata.filter((form) => {
            if (!form.start_ejecution && !form.end_ejecution) return true

            const startEjecution = new Date(form.start_ejecution)
            const endEjecution = new Date(form.end_ejecution)
            return startEjecution <= currentDate && endEjecution >= currentDate
        })

        return filter_forms
    }

    const navigateToPF = useCallback(
        (index: number) => {
            console.log('127 -- ')

            navigation.navigate('PerfectStoreView', {
                perfectStore: perfectStoreArray,
                selectedIndex: index,
                storeInfo: store,
            })
        },
        [navigation, perfectStoreArray, store],
    )

    const navigateToForms = useCallback(
        async (indexOrIdOrName: number | string, nameFormFallback?: string) => {
            let finalIndex: number = -1

            if (typeof indexOrIdOrName === 'string') {
                // Intento 1: Buscar por _id
                finalIndex = formsContext.findIndex(
                    (form) => form._id === indexOrIdOrName,
                )

                if (finalIndex !== -1) {
                    console.log(
                        'navigateToForms -- Found form by _id at INDEX:',
                        finalIndex,
                    )
                } else {
                    // Intento 2: Buscar por name_form (puede venir como parámetro o usar el mismo string)
                    const searchName = nameFormFallback || indexOrIdOrName
                    finalIndex = formsContext.findIndex(
                        (form) => form.name_form === searchName,
                    )

                    if (finalIndex !== -1) {
                        console.log(
                            'navigateToForms -- Found form by name_form at INDEX:',
                            finalIndex,
                        )
                    } else {
                        console.error(
                            'navigateToForms -- Form not found with _id or name_form:',
                            indexOrIdOrName,
                        )
                        return
                    }
                }
            } else {
                // Si recibimos un índice numérico, usarlo directamente (fallback final)
                finalIndex = indexOrIdOrName
                console.log('navigateToForms -- Using provided INDEX:', finalIndex)
            }

            // ✅ Intentar usar checkInID si es válido
            let checkin_id_to_use = isValidMongoId(checkInID) ? checkInID : null

            // ✅ Si no es válido, buscar en la BD local
            if (!checkin_id_to_use) {
                const checkin = await schedulesServices.get_checkin(
                    storeID,
                    scheduleID,
                )
                if (checkin && checkin.length > 0) {
                    checkin_id_to_use = checkin[checkin.length - 1].checkin_id
                    console.log(
                        '✅ [navigateToForms] checkin_id encontrado en BD local:',
                        checkin_id_to_use,
                    )
                } else {
                    console.log(
                        '⚠️ [navigateToForms] No se encontró checkin_id en BD local',
                    )
                }
            }

            // ✅ Si tenemos conexión y no encontramos checkin_id, intentar del servidor
            if (!checkin_id_to_use) {
                const hasConnection = await validateConnectionNetwork()
                if (hasConnection) {
                    const checkin = await schedulesServices.get_checkin(
                        storeID,
                        scheduleID,
                    )
                    checkin_id_to_use =
                        checkin && checkin.length > 0
                            ? checkin[checkin.length - 1].checkin_id
                            : null
                    console.log(
                        '✅ [navigateToForms] checkin_id del servidor:',
                        checkin_id_to_use,
                    )
                }
            }

            // ✅ Navegar siempre, incluso sin checkin_id (se manejará en ExecutionView/useFormView)
            console.log(
                '🚀 [navigateToForms] Navegando con checkin_id:',
                checkin_id_to_use,
            )
            navigation.navigate('ExecutionView', {
                forms: formsContext,
                selectedIndex: finalIndex,
                schedule_id: scheduleID,
                store_id: storeID,
                storeInfo: store,
                checkin_id: checkin_id_to_use,
                status_store: status_store,
                statusCheckin: statusCheckin,
            })
            const form_id = formsContext[finalIndex]?._id
                ? formsContext[finalIndex]._id
                : ''
            TrackingServices.addTracking(
                form_id,
                TRACKINGS_TYPES.NAVIGATE_FORM_STORE,
                'ExecutionView',
            )
        },
        [
            navigation,
            formsContext,
            scheduleID,
            storeID,
            store,
            checkInID,
            status_store,
            statusCheckin,
        ],
    )

    const saveItemSteps = async (item) => {
        console.log('128 -- ')

        try {
            setStepsDistri(item)
        } catch (error) {
            console.error('🚀 ~ saveItemSteps ~ error:', error)
        }
    }

    const saveSteps = async (dataSteps) => {
        console.log('129 -- ')

        try {
            console.log('envio steps y llamo al checkin....', dataSteps.length)
            await checkIn(true, dataSteps)
            closeBottomSheet(true)
            setStatusSteps(CHECKIN_REALIZADO)
        } catch (error) {
            console.error('🚀 ~ saveSteps ~ error:', error)
        }
    }

    const validate_steps = async (type, number = null) => {
        console.log('130 -- ')

        try {
            if (steps.length > 0) {
                let steps_checkin = steps.filter((item) => item.type == type)
                //console.log(type, '🚀 ~ constvalidate_steps= ~ steps_checkin:', steps_checkin)
                if (steps_checkin.length > 0) {
                    switch (type) {
                        case CONSTANTS_TYPES_STEPS.CHECKIN_STEPS_DISTRIBUTOR:
                            try {
                                //await schedulesServices.get_checkin_steps(storeID, scheduleID).then((response) => {
                                // if (!response) {
                                let new_steps: { label: string; type: any }[] =
                                    steps_checkin[0]['forms'].map((item: any) => {
                                        return {
                                            label: item?.label as string,
                                            type: item?.type,
                                        }
                                    })
                                //  alert('tenes steps pendientes')
                                openBottomSheet(
                                    <FormSteps
                                        fields={new_steps}
                                        store_id={storeID}
                                        schedule_id={scheduleID}
                                        closeBottomSheet={closeBottomSheet}
                                        saveSteps={saveSteps}
                                        saveItemSteps={saveItemSteps}
                                        option={type}
                                    />,
                                    null,
                                    false, //false para que no se pueda cerrar el modal
                                )
                                return {
                                    status: 0,
                                    step: '',
                                    message: 'tiene que haer el form de steps',
                                }
                                // } else {
                                //     setStatusSteps(CHECKIN_REALIZADO)
                                //     //   alert('ya realizaste los steps')
                                //     return {
                                //         status: 1,
                                //         step: '',
                                //         message: false,
                                //     }
                                // }
                                // })
                            } catch (error) {
                                console.error(error)
                                return {
                                    status: -1,
                                    step: '',
                                    message: false,
                                }
                            }
                        case CONSTANTS_TYPES_STEPS.CHECKIN_STEPS:
                            try {
                                await schedulesServices
                                    .get_checkin_steps(storeID, scheduleID)
                                    .then((response) => {
                                        if (!response) {
                                            let new_steps: {
                                                label: string
                                                type: any
                                            }[] = steps_checkin.map((item: any) => {
                                                return {
                                                    label: item?.label as string,
                                                    type: item?.type_action,
                                                }
                                            })
                                            //  alert('tenes steps pendientes')
                                            const snapPoints = ['60%']
                                            openBottomSheet(
                                                <FormSteps
                                                    fields={new_steps}
                                                    store_id={storeID}
                                                    schedule_id={scheduleID}
                                                    closeBottomSheet={
                                                        closeBottomSheet
                                                    }
                                                    saveSteps={saveSteps}
                                                    saveItemSteps={saveItemSteps}
                                                    option={type}
                                                />,
                                                snapPoints,
                                            )
                                        } else {
                                            setStatusSteps(CHECKIN_REALIZADO)
                                            //   alert('ya realizaste los steps')
                                            return {
                                                status: 1,
                                                step: '',
                                                message: false,
                                            }
                                        }
                                    })
                            } catch (error) {
                                console.error(error)
                                return {
                                    status: -1,
                                    step: '',
                                    message: false,
                                }
                            }
                            break
                        case CONSTANTS_TYPES_STEPS.STOPS_BY:
                            if (number) {
                                const number_checkin = number + 1
                                let filter_step = steps_checkin.find(
                                    (item) => item.checkins == number_checkin,
                                )

                                if (steps_checkin.length > 0 && filter_step) {
                                    // alert(
                                    //     `¡Felicitaciones! Has alcanzado tu check-in número ${number}. No es necesario que completes el formulario adicional.`,
                                    // )
                                    //busco el name del form
                                    let nameform =
                                        await schedulesServices.getFormName(
                                            filter_step['forms'][0]['_id'],
                                        )
                                    return {
                                        status: 1,
                                        step_number: number,
                                        step: filter_step,
                                        message:
                                            languageFile.visiting_your_store +
                                            `${number_checkin}.` +
                                            languageFile.you_can_check_out +
                                            `${nameform}.`,
                                    }
                                } else {
                                    return {
                                        status: -1,
                                        step: {},
                                        message: false,
                                    }
                                }
                            } else {
                                return {
                                    status: -1,
                                    step: {},
                                    message: false,
                                }
                            }
                        case CONSTANTS_TYPES_STEPS.OBJECTIVE_COMPLETE:
                            //verifico si cumpli el objetivo
                            if (number) {
                                //busco si la agenda tiene additional objetives o tomo el de campaña
                                let filter_step_objetive = steps.find(
                                    (item) =>
                                        item.type ==
                                        CONSTANTS_TYPES_STEPS.OBJECTIVES,
                                )
                                await schedulesServices
                                    .get_schedule(scheduleID)
                                    .then((schedule) => {
                                        if (
                                            schedule.additional &&
                                            schedule.additional.objective &&
                                            schedule.additional.objective.length > 0
                                        ) {
                                            //ARMO EL STEP
                                            filter_step_objetive = {
                                                checkins:
                                                    parseInt(
                                                        schedule.additional
                                                            .objective[0][
                                                            'objetive'
                                                        ],
                                                    ) +
                                                    (schedule.additional.stop_by
                                                        ? schedule.additional.stop_by
                                                              .length
                                                        : 0),
                                                forms: [
                                                    {
                                                        _id: schedule['form_finish']
                                                            ? schedule[
                                                                  'form_finish'
                                                              ]['_id']
                                                            : null,
                                                        status: 2,
                                                    },
                                                ],
                                            }
                                        }
                                    })

                                // console.log('🚀 ~ constvalidate_steps= ~ filter_step_objetive:', filter_step_objetive)
                                if (
                                    filter_step_objetive &&
                                    number >= filter_step_objetive.checkins
                                ) {
                                    return {
                                        status: 1,
                                        step_number: number,
                                        step: steps_checkin[0],
                                        message: languageFile.you_met_the_goal,
                                    }
                                } else {
                                    return {
                                        status: -1,
                                        step: {},
                                        message: false,
                                    }
                                }
                            } else {
                                return {
                                    status: -1,
                                    step: {},
                                    message: false,
                                }
                            }

                        default:
                            return {
                                status: -1,
                                step: '',
                                message: false,
                            }
                    }
                } else {
                    return {
                        status: 1,
                        step: '',
                        message: false,
                    }
                }
            } else {
                setStatusSteps(CHECKIN_REALIZADO)
                return {
                    status: -1,
                    step: '',
                    message: false,
                }
            }
        } catch (error) {
            console.error('954 - validate_steps ~ error:', error)
            throw new Error(error)
        }
    }

    const calculateRelevProgress = async () => {
        if (forms_relevant.length === 0) {
            setProgressRelev(0)
            return
        }

        const completedForms = formsContext.filter(
            (form) =>
                form?.status === FORM_SCHEDULE_STATUS.COMPLETED &&
                forms_relevant.some((relevant) => relevant._id === form._id),
        )
        const progress = (completedForms.length / forms_relevant.length) * 100

        // Redondear hacia abajo para eliminar los decimales
        const roundedProgress = Math.floor(progress)

        setProgressRelev(roundedProgress >= 100 ? 100 : roundedProgress)
    }

    const validate_forms_relevant = async () => {
        let response = { status: 1, message: 'todo ok', form_id: null }
        if (forms_relevant && forms_relevant.length > 0) {
            const count = await schedulesServices.get_total_checkin_count(scheduleID)
            let verify_step = await validate_steps(
                CONSTANTS_TYPES_STEPS.OBJECTIVE_COMPLETE,
                count,
            )
            if (!verify_step || verify_step.status != 1) {
                verify_step = await validate_steps(
                    CONSTANTS_TYPES_STEPS.STOPS_BY,
                    count,
                )
            }

            let filteredForms = forms_relevant

            if (
                verify_step.status == 1 &&
                verify_step['step'] &&
                verify_step['step']['forms'].length > 0
            ) {
                filteredForms = forms_relevant.filter(
                    (elem) => elem._id !== verify_step['step']['forms'][0]['_id'],
                )
            }
            // console.log('1051 - 🚀 ~ constvalidate_forms_relevant= ~ filteredForms:', filteredForms, verify_step)

            let groupedForms = filteredForms.reduce((acc, form) => {
                // Si tiene activity_id, agrupamos por esa clave
                if (form.activity_id) {
                    // Verificamos si ya existe un grupo para ese activity_id
                    const group = acc.find(
                        (item) => item.activity_id === form.activity_id,
                    )
                    if (group) {
                        // Si existe el grupo, agregamos el _id del formulario al array 'forms'
                        group.forms.push(form._id)
                    } else {
                        // Si no existe el grupo, creamos uno nuevo con el _id del formulario
                        acc.push({
                            _id: form._id,
                            activity_id: form.activity_id,
                            forms: [form._id],
                            hex_color: form.hex_color,
                            name: form.name,
                        })
                    }
                } else {
                    // Si no tiene activity_id, simplemente lo agregamos sin modificaciones
                    acc.push({
                        _id: form._id,
                        hex_color: form.hex_color,
                        name: form.name,
                    })
                }

                return acc
            }, [])

            groupedForms = groupedForms.filter((form) => {
                if (!form || !form._id) return false
                return formsContext?.some(
                    (formContext) =>
                        formContext?._id.toString() === form._id.toString(),
                )
            })

            groupedForms = formsContext
                .map((formCont) =>
                    groupedForms.find(
                        (form) => form?._id?.toString() === formCont._id?.toString(),
                    ),
                )
                .filter(Boolean)

            for (let i = 0; i < groupedForms.length; i++) {
                const form = groupedForms[i]

                // Verificamos si tiene la propiedad 'forms' (es decir, si tiene formularios asociados con el mismo activity_id)
                if (form.forms && form.forms.length > 0) {
                    let isCompleteGroup = false

                    // Recorremos cada formulario en la propiedad 'forms' y verificamos si al menos uno está completo
                    for (let j = 0; j < form.forms.length; j++) {
                        const formId = form.forms[j]
                        const isComplete = await schedulesServices.isFormComplete(
                            formId,
                            storeID,
                            scheduleID,
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                            FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                        )

                        if (isComplete) {
                            isCompleteGroup = true
                            break // Si al menos uno está completo, no es necesario seguir buscando
                        }
                    }

                    // Si el grupo completo no está hecho, mostramos el mensaje de que falta completar el formulario
                    if (!isCompleteGroup) {
                        const name_form = await schedulesServices.getFormName(
                            form._id,
                        )
                        response = {
                            status: 0,
                            message:
                                languageFile.you_must_complete_the_survey +
                                `${name_form}`,
                            form_id: form._id,
                        }
                        break // Salimos del ciclo porque no se puede continuar hasta completar el formulario
                    }
                } else {
                    // Si no tiene 'forms', verificamos el formulario individual
                    let isComplete = await schedulesServices.isFormComplete(
                        form._id,
                        storeID,
                        scheduleID,
                        FORM_SCHEDULE_STATUS.COMPLETED,
                        FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                        FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                    )

                    // console.log('789 --- isComplete: ', isComplete, form._id, storeID, scheduleID)

                    // Si no está completo, validamos el estado del formulario en el contexto
                    if (!isComplete) {
                        const formIndex = formsContext.findIndex(
                            (formulario) => formulario._id == form._id,
                        )
                        // console.log('🚀 ~ constvalidate_forms_relevant= ~ formIndex:', formIndex)
                        if (formIndex !== -1) {
                            const STATUS_VALIDATES = [
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                            ]

                            if (
                                STATUS_VALIDATES.includes(
                                    formsContext[formIndex].status,
                                )
                            ) {
                                isComplete = true
                            }
                        }
                    }

                    // Si no está completo, mostramos el mensaje de que falta completar el formulario
                    if (!isComplete) {
                        let name_form = await schedulesServices.getFormName(form._id)
                        response = {
                            status: 0,
                            message:
                                languageFile.you_must_complete_the_survey +
                                `${name_form}`,
                            form_id: form._id,
                        }
                        break // Salimos del ciclo porque no se puede continuar hasta completar el formulario
                    }
                }
            }
        }

        return response
    }

    const checkIn = async (cont = false, itemsSteps = []) => {
        console.log(
            'form ids fqa => ',
            formsContext.map((form) => form.form_id_fqa),
        )
        const formsIdsFqa = formsContext.map((form) => form.form_id_fqa)
        // fecha_hoy.setHours(0, 0, 0, 0)
        setLoadingCheckin(true)

        // verificar si estoy entre la distancia que me llega en el store
        console.log(
            '------------------> ~ checkIn -------------------:',
            cont,
            itemsSteps.length,
        )

        if (checkoutInProcess) {
            return
        }
        try {
            setCheckoutInProcess(true)
            let { status, store, schedule_advances } =
                await schedulesServices.validateCheckins(scheduleID)

            console.log('🚀 ~ checkIn ~ status:', status, schedule_advances)
            //valido fechaa
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)

            let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

            console.log(
                status,
                '-----------fecha de hoyyy ~ fecha_hoy:',
                fecha_hoy_str,
                schedule_advances,
            )

            if (
                !status &&
                schedule_advances &&
                schedule_advances.date_init < fecha_hoy_str
            ) {
                console.log(
                    '-----------esta vencidoo~ fecha_hoy:',
                    fecha_hoy_str,
                    schedule_advances.date_init,
                )
                status = true
            }

            // console.log('🚀 ~ checkIn ~ status:', status)

            if (!status) {
                let title = languageFile.checkin_blocked
                let desc = languageFile.close_the_open_checkin
                let button = languageFile.accept

                if (store && store.name && store.code) {
                    desc =
                        languageFile.close_the_checkin_opened_in +
                        `${store.name}, ${store.code}`
                }

                return openBottomSheet(
                    <BottomSheetAlert
                        image={require('../../../assets/stores/checkinLocked.png')}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={closeBottomSheet}
                    />,
                    ['50%'],
                )
            }

            const cordUser = {
                lat: userLat,
                lng: userLng,
                last_update_coords: lastUpdateCoorsUser,
            }

            const canValidateDistance = validateUpdateCoordsTime(lastUpdateCoorsUser)

            const isValidDistanceCheckin =
                await schedulesServices.isValidDistanceCheckin(storeID, cordUser)

            if (!isValidDistanceCheckin && canValidateDistance) {
                //* se comenta ya que no funcionan bien los modales en android
                // let title = languageFile.checkin_out_of_range
                // let desc = languageFile.more_meters_from_the_store
                // let button = languageFile.accept

                // return openBottomSheet(
                //     <BottomSheetAlert
                //         image={require('../../../assets/stores/outOfRange.png')}
                //         title={title}
                //         desc={desc}
                //         button={button}
                //         closeBottomSheet={closeBottomSheet}
                //     />,
                //     ['40%'],
                // )
                // return alert('Fuera de rango para realizar checkin')
                let distanceValue = 50
                const maximumDistance =
                    await schedulesServices.getStoreMaxDistance(storeID) // distancia por defecto de 50 mts
                if (expoConfig.slug === 'beiersdorf-wts') {
                    if (maximumDistance && maximumDistance > 0) {
                        distanceValue = maximumDistance
                    }
                }

                setValidateCheckin({
                    isPosibleCheckin: true,
                    messageValidateCheckin: `🚫 Estás fuera de los ${distanceValue} mts.`,
                })

                return
            }

            const validate = await validate_steps(
                CONSTANTS_TYPES_STEPS.CHECKIN_STEPS,
            )

            // const validate_step_distri = await validate_steps(CONSTANTS_TYPES_STEPS.CHECKIN_STEPS_DISTRIBUTOR, null)
            // console.log(' validate_step_distri:', validate_step_distri, cont)
            // if (validate_step_distri && validate_step_distri.status == 0 && itemsSteps.length == 0) {
            //     //status 0 es que tiene ese step y lo tiene que realizar
            //     console.log('====================================')
            //     console.log('hay que hacer el form de stepss,  itemsSteps.length', itemsSteps.length)
            //     console.log('====================================')
            //     return
            // }
            //throw 'para'

            if (
                statusSteps === CHECKIN_REALIZADO ||
                cont ||
                (validate && validate.status == 1)
            ) {
                let dif_utc = -new Date().getTimezoneOffset() / 60

                let checkinID = Date.now().toString() // checkinID temporal

                let status_send = 0
                let objectives = []
                //agrego o inc los contadores de forms

                let schedule = await schedulesServices.get_schedule(scheduleID)

                // console.log('🚀 ~ checkIn ~ schedule:', schedule.additional)
                if (
                    schedule &&
                    schedule.additional &&
                    schedule.additional.objective &&
                    schedule.additional.objective.length > 0 &&
                    schedule.additional.objective.some(
                        (item) =>
                            item.type ==
                            CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP,
                    )
                ) {
                    let steps_group_forms = schedule.additional.objective.find(
                        (item) =>
                            item.type ==
                            CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP,
                    )
                    if (
                        steps_group_forms &&
                        steps_group_forms.form.length > 0 &&
                        steps_group_forms.name_required.length > 0
                    ) {
                        let get_names_forms = await schedulesServices.get_name_forms(
                            steps_group_forms.name_required,
                            steps_group_forms.form,
                            forms,
                        )
                        objectives = Array.isArray(get_names_forms)
                            ? get_names_forms
                            : []
                    }
                }

                const { existsInDB, _id_mongoDB } =
                    await schedulesServices.getExistsInDB(storeID)

                const hasConnection = await validateConnectionNetwork()

                if (hasConnection && existsInDB) {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ''
                    const data = {
                        authToken: authToken,
                        body: {
                            store_id: _id_mongoDB ? _id_mongoDB : storeID,
                            lat: String(userLat),
                            lng: String(userLng),
                            date_init: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            schedule_id: scheduleID,
                            objectives: objectives,
                            steps_distributor: itemsSteps,
                        },
                    }

                    // console.log('1251 - 🚀 ~ checkIn ~ data:', data, itemsSteps.length)
                    const res = await request_checkin(data)

                    //console.log('🚀 ~ checkIn ~ res:', res)
                    if (res && res.status) {
                        checkinID = res.response?.single?.checkin_status?._id
                        console.log('🚀 ~ checkIn ~ response:', res.response.single)
                        status_send = 1

                        console.log('formsIdsFqa ====> ', formsIdsFqa)
                        console.log('checkinID ====> ', checkinID)

                        await schedulesServices.updateKeyCheckinFqa(
                            checkinID,
                            formsIdsFqa,
                        )

                        if (res.response?.single?.advance) {
                            await addOrUpdateAdvanceSchedule(
                                res.response?.single?.advance,
                            )
                        }
                    }
                    //checkinID = (res && res?.single?.checkin_status?._id) ?? ''
                    // console.log("872 ---- 🚀 ~ checkIn ~ checkinID:", checkinID)
                    setCurrentCheckin(checkInID)
                    setCheckinID(checkinID)
                }

                const data_local = {
                    date: new Date().toISOString(),
                    store_id: existsInDB ? _id_mongoDB : storeID,
                    lat_checkin: String(userLat),
                    lng_checkin: String(userLng),
                    schedule_id: scheduleID,
                    date_init: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    status: status_send
                        ? FORM_SCHEDULE_STATUS.COMPLETED
                        : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    objectives: objectives,
                    steps_distributor: itemsSteps,
                    formsIdsFqa: formsIdsFqa,
                }

                const checkin = await schedulesServices.add_checkin(
                    data_local,
                    checkinID,
                )

                if (checkin && checkin.checkin_id) {
                    setCheckinID(checkin.checkin_id)
                }

                // Inicializar registros de tracking en FORMS_PENDING_SYNC para este checkin.
                // Crea un registro PENDING por cada form visible, scopeado al checkin_id.
                const resolvedCheckinId = checkin?.checkin_id ?? checkinID
                console.log('🚀 ~ checkIn ~ resolvedCheckinId:', resolvedCheckinId)
                await schedulesServices.initCheckinFormTracking(
                    resolvedCheckinId,
                    scheduleID,
                    storeID,
                    formsContext,
                )

                TrackingServices.addTracking(
                    checkinID,
                    TRACKINGS_TYPES.CHECKIN,
                    'StoreDetail',
                )

                if (!status_send) {
                    // ✅ Usar retry logic para evitar "database is locked"
                    await retryDbOperation(async () => {
                        await schedulesServices.upsertScheduleAdvanceLocal(
                            scheduleID,
                            storeID,
                            FORM_SCHEDULE_STATUS.IN_PROGRESS,
                            new Date().toISOString(),
                            [],
                            objectives,
                        )
                    })
                }
                //si hay algo en los steps los limpio
                clearStepsDistributor()
                setStatusCheckin(CHECKIN_REALIZADO)
                console.log(
                    '✅ [checkIn] statusCheckin actualizado a CHECKIN_REALIZADO (1)',
                )
                // ✅ CRÍTICO: Actualizar status_store ANTES de updateStatusForms para que esté sincronizado
                setStatus_store(CampaignStatus.STATUS_FORM_IN_PROGRESS)

                // ✅ Usar retry logic para evitar "database is locked"
                await retryDbOperation(async () => {
                    await schedulesServices.update_status_store(
                        storeID,
                        scheduleID,
                        CampaignStatus.STATUS_FORM_IN_PROGRESS,
                        new Date().toISOString(),
                    )
                })

                // ✅ CRÍTICO: Bloquear recarga de datos durante la actualización
                isUpdatingFormStatusRef.current = true
                console.log(
                    '🔒 [checkIn] Bloqueando recarga de datos durante actualización de formularios',
                )
                console.log('📊 [checkIn] reload ANTES de setReloadChange:', reload)

                // ✅ CRÍTICO: Esperar a que updateStatusForms complete y propague cambios
                console.log(
                    '🔵 [checkIn] Actualizando status de formularios a PENDING...',
                )
                await updateStatusForms(FORM_SCHEDULE_STATUS.PENDING)
                console.log(
                    '✅ [checkIn] Status de formularios actualizado - esperando propagación completa',
                )

                // ✅ CRÍTICO: Esperar más tiempo para asegurar que React propague completamente el cambio
                // Esto permite que todos los componentes hijos se actualicen con el nuevo estado
                await new Promise((resolve) => setTimeout(resolve, 150))

                // ✅ Ahora sí, forzar un reload para refrescar cualquier estado derivado
                setReloadChange()
                console.log(
                    '✅ [checkIn] setReloadChange() llamado después de propagación completa',
                )

                // ✅ Desbloquear después de que todo esté sincronizado
                isUpdatingFormStatusRef.current = false
                console.log('🔓 [checkIn] Recarga de datos desbloqueada')

                // Actualiza campaign_status en el contexto global de la tienda
                updateStoreStatus(storeID, CampaignStatus.STATUS_FORM_IN_PROGRESS)

                await validateStatusCheckin()

                // ✅ Sincronizar con el servidor para obtener el estado real de los formularios después del checkin
                if (hasConnection && existsInDB) {
                    try {
                        const session = await fetchAuthSession()
                        const authToken =
                            session.tokens?.accessToken?.toString() || ''
                        const response = await request_get_store({
                            authToken,
                            store_id: _id_mongoDB ? _id_mongoDB : storeID,
                            schedule_id: scheduleID,
                        })
                        if (
                            response &&
                            response.status &&
                            response.response.status == 1
                        ) {
                            let data = response.response
                            if (data && data.status == 1 && data.single) {
                                // Actualizar usuarios en dropdowns si existen
                                if (
                                    data.single.forms_users &&
                                    data.single.forms_users.length > 0
                                ) {
                                    await agregateUsersFormDropdown(
                                        data.single.forms_users,
                                    )
                                }
                                // ❌ COMENTADO: No recargar todo para evitar sobrescribir el status recién actualizado
                                // await setData(data.single)
                                console.log(
                                    'ℹ️ [checkIn] Datos del servidor recibidos pero NO recargados para preservar status PENDING',
                                )
                            }
                        }
                    } catch (error) {
                        console.error(
                            'Error al sincronizar con get_store después del checkin:',
                            error,
                        )
                    }
                } else {
                    // ❌ COMENTADO: No recargar para evitar sobrescribir el status recién actualizado
                    // await fetchDataLocalNew()
                    console.log(
                        'ℹ️ [checkIn] Sin conexión - preservando status PENDING sin recargar',
                    )
                }
                const count =
                    await schedulesServices.get_total_checkin_count(scheduleID)

                let stop = await validate_steps(
                    CONSTANTS_TYPES_STEPS.STOPS_BY,
                    count,
                )

                if (stop && stop?.status == 1 && stop.step) {
                    let title = languageFile.now_is_your_turn
                    let desc = stop?.message ?? ''
                    let button = languageFile.accept

                    openBottomSheet(
                        <BottomSheetAlert
                            image={require('../../../assets/stores/stepsStore.png')}
                            title={title}
                            desc={desc}
                            button={button}
                            closeBottomSheet={closeBottomSheet}
                        />,
                    )

                    // alert(stop?.message)
                }
            }
        } catch (error) {
            console.error('665 ------ checkIn: ', error)
        } finally {
            console.log('1382 --- finalizo checkin')
            setCheckoutInProcess(false)
            setLoadingCheckin(false)
        }
    }

    /**
     * @description valida si tengo formularios en progreso y pendientes antes de realizar checkout STATUS = 1 : NO TENGO PENDIENTES NI EN CURSOS, STATUS = 0 : TENGO PENDIENTES O EN CURSO
     */
    const validate_forms_in_progress_pending = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''
            const forms_in_progress = formsContext.filter(
                (form) => form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS,
            )
            const forms_pending = formsContext.filter(
                (form) => form.status === FORM_SCHEDULE_STATUS.PENDING,
            )

            if (forms_in_progress && forms_in_progress.length > 0) {
                const nameForms = forms_in_progress.map((form) => form.name_form)
                if (nameForms && nameForms.length > 0) {
                    message =
                        languageFile.surveys_in_progress + `${nameForms.join(', ')}`
                }
                form_id = forms_in_progress[0]['_id']
            } else {
                status = 1
            }

            return {
                status,
                title: languageFile.want_to_checkout,
                message,
                form_id,
            }
        } catch (error) {
            console.error('586 --- validate_forms_in_progress_pending: ')
        }
    }

    const validate_forms_schedule_objective = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''
            const forms_objectives = formsContext.filter(
                (form) =>
                    form.objective == 1 &&
                    form.status != FORM_SCHEDULE_STATUS.COMPLETED &&
                    form.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )
            console.log('forms_objectives:', forms_objectives.length)

            if (forms_objectives && forms_objectives.length > 0) {
                const nameForms = forms_objectives.map((form) => form.name_form)
                if (nameForms && nameForms.length > 0) {
                    message =
                        'Hay formularios obligatorios sin responder: ' +
                        `${nameForms.join(', ')}` +
                        ', lo que significa que el objetivo no se sumará en la tienda.'
                }
                form_id = forms_objectives[0]['_id']
            } else {
                status = 1
            }

            return {
                status,
                title: 'hay formularios de Objetivos pendientes',
                message,
                form_id,
            }
        } catch (error) {
            console.error(
                '🚀 ~ constvalidate_forms_schedule_objective= ~ error:',
                error,
            )
        }
    }

    const get_names_forms_pendings = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''

            const forms_objectives = formsContext.filter(
                (form) =>
                    form.objective == 1 &&
                    form.status != FORM_SCHEDULE_STATUS.COMPLETED &&
                    form.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )

            if (forms_objectives && forms_objectives.length > 0) {
                const nameForms = forms_objectives.map((form) => {
                    return {
                        form_name: form.name_form,
                        form_id: form._id,
                    }
                })

                if (nameForms && nameForms.length > 0) {
                    message = `⚠️ Obligatorio: ${nameForms[0]['form_name']}`
                    form_id = nameForms[0]['form_id']
                }
            } else {
                status = 1
            }

            return {
                status,
                message,
                form_id,
            }
        } catch (error) {
            console.error('🚀 ~ get_names_forms_pendings= ~ error:', error)
        }
    }

    const findFormsRealizedInStore = async () => {
        try {
            const { existsInDB, _id_mongoDB } =
                await schedulesServices.getExistsInDB(storeID)

            // Limitar la búsqueda a los formularios del día actual para evitar mezclar estados
            const generateIdDate = generateDayUniqueId()
            const forms = await schedulesServices.getFormsRealizedByStore(
                scheduleID,
                storeID,
                _id_mongoDB,
                generateIdDate,
            )

            let filterFormsPending = forms.filter(
                (form) =>
                    form.status_send == FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )

            if (existsInDB && filterFormsPending.length > 0) {
                filterFormsPending = filterFormsPending.map((form) => {
                    return {
                        ...form,
                        store_id: _id_mongoDB,
                    }
                })
            }
            return filterFormsPending
        } catch (error) {
            console.error('Error en findFormsRealizedInStore:', error)
            return []
        }
    }

    const checkOut = async () => {
        if (checkoutInProcess) {
            return
        }
        const hasConnection = await validateConnectionNetwork()
        console.log(
            '🚀 ~ checkOut ~ hasConnection:',
            hasConnection,
            checkInID,
            checkInIDLocal,
        )

        let dataCheckinID = checkInID
        let dataCheckinIDLocal = checkInIDLocal

        if (
            (dataCheckinID == '' || dataCheckinID == null) &&
            (dataCheckinIDLocal == '' || dataCheckinIDLocal == null)
        ) {
            const dataCheckin = await schedulesServices.get_checkin(
                storeID,
                scheduleID,
            )
            if (dataCheckin) {
                const index = dataCheckin.length - 1
                dataCheckinIDLocal = dataCheckin[index]._id
                dataCheckinID = dataCheckin[index].checkin_id
            } else {
                //alert(No se encontra el checkin.)
                alert(languageFile.no_checkin_found)
                return
            }

            //vuelvo a consultar el id checkin
        }
        setCheckoutInProcess(true)
        console.log('checkOut')
        let checkOutID = ''
        let status_store = CampaignStatus.STATUS_FORM_PENDING_SYNC
        let dif_utc = 0
        let status_send = 0

        const user = await UserServices.getUser()
        const shouldCreatePerfectStore = user?.name_group == CLIENTS.ONE_SAVENCIA

        generateKpiForms(
            formsContext.map((form) => form._id),
            storeID,
            scheduleID,
            shouldCreatePerfectStore,
        )

        try {
            dif_utc = -new Date().getTimezoneOffset() / 60

            const hasConnection = await validateConnectionNetwork()

            const { existsInDB, _id_mongoDB } =
                await schedulesServices.getExistsInDB(storeID)
            if (hasConnection && checkInID && existsInDB) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''

                dataCheckinID = await getCheckinId(dataCheckinID)
                console.log('new dataCheckinID => ', dataCheckinID)

                if (isValidMongoId(dataCheckinID)) {
                    const data = {
                        authToken: authToken,
                        body: {
                            store_id: _id_mongoDB ? _id_mongoDB : storeID,
                            id_check_in: dataCheckinID,
                            lat: String(userLat),
                            lng: String(userLng),
                            date_finish: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            schedule_id: scheduleID,
                        },
                    }

                    const res = await request_checkout(data)

                    if (res && res.status) {
                        status_send = res.status
                        // console.log('status_send => ', status_send)
                        checkOutID = res?.response.single?.checkin_status?._id ?? ''
                        const single = res.response.single
                        status_store =
                            res?.response.single?.status_store ??
                            CampaignStatus.STATUS_FORM_APPROVED

                        await createCheckinLocal(single?.check_in)
                    }
                }
            }

            //* envio de forms
            // try {
            //     sendFormsRealizedStore()
            // } catch (error) {
            //     console.error('Error en sendFormsRealizedStore:', error)
            // }
            // // console.log('🚀 ~ checkoutID ~ data_local:', data_local)
        } catch (error) {
            console.error('1checkOut ~ error:', error)
        } finally {
            try {
                const { existsInDB, _id_mongoDB } =
                    await schedulesServices.getExistsInDB(storeID)

                const newStoreId = existsInDB ? _id_mongoDB : storeID

                const data_local = {
                    date: new Date().toISOString(),
                    store_id: String(newStoreId ?? ''),
                    lat_checkout: String(userLat),
                    lng_checkout: String(userLng),
                    schedule_id: scheduleID,
                    date_finish: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    checkin_id: dataCheckinID
                        ? String(dataCheckinID)
                        : null,
                    checkin_id_local: dataCheckinIDLocal
                        ? dataCheckinIDLocal.toString()
                        : null,
                    status: status_send
                        ? FORM_SCHEDULE_STATUS.COMPLETED
                        : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                }
                await schedulesServices.add_checkout(data_local, checkOutID)
                setStatusCheckin(CHECKOUT_REALIZADO)

                await schedulesServices.update_status_store(
                    newStoreId,
                    scheduleID,
                    status_store,
                    new Date().toISOString(),
                )

                await schedulesServices.updateStatusCheckoutFormsQuestionsAnswers(
                    scheduleID,
                    storeID,
                    1,
                )

                TrackingServices.addTracking(
                    checkOutID,
                    TRACKINGS_TYPES.CHECKOUT,
                    'StoreDetail',
                )

                // Marcar formularios como BLOQUEADOS localmente después del checkout.
                // Antes solo se hacía si había conexión remota; al dejarlo condicional
                // se generan estados inconsistentes cuando el checkout es offline.
                await updateStatusForms(FORM_SCHEDULE_STATUS.BLOCKED)
                // Actualiza campaign_status en el contexto global de la tienda
                updateStoreStatus(newStoreId, status_store)

                setStoreStatus(newStoreId, status_store)

                validateStatusCheckOut()
            } catch (error) {
                console.error('checkOut ~ error en finally:', error)
            } finally {
                setCheckoutInProcess(false)
                closeBottomSheet(true)
                // navigation.goBack() // comento para evitar que vuelva a la pantalla anterior automáticamente después del checkout
            }
        }
    }

    const createCheckinLocal = async (checkInData) => {
        try {
            if (!checkInData || checkInData == null || checkInData == undefined) {
                console.error(
                    'createCheckin: checkInData no es válido:',
                    checkInData,
                )
                return
            }

            console.log('createCheckin: checkInData recibido:', checkInData)

            // revisar si existe el checkin, si no existe, lo creo. si no existe return

            const checkin = await schedulesServices.get_checkin(
                checkInData.store_id,
                checkInData.schedule_id,
            )

            if (checkin && checkin.length > 0) {
                console.log('createCheckin: checkin ya existe, no se crea uno nuevo')
                return
            }

            const formsIdsFqa = formsContext.map((form) => form.form_id_fqa)

            // creo el checkin local
            const data_local = {
                date: checkInData.date_init,
                store_id: checkInData.store_id,
                lat_checkin: String(checkInData.lat_checkin),
                lng_checkin: String(checkInData.lng_checkin),
                schedule_id: checkInData.schedule_id,
                date_init: checkInData.date_init,
                dif_utc: checkInData.dif_utc,
                status: checkInData.status,
                objectives: checkInData.objectives || [],
                steps_distributor: checkInData.steps_distributor || [],
                formsIdsFqa: formsIdsFqa,
            }

            const newCheckin = await schedulesServices.add_checkin(
                data_local,
                checkInData._id,
            )
        } catch (error) {
            console.error('Error en createCheckin:', error)
        }
    }

    const generateKpiForms = async (
        formsIds,
        storeId,
        scheduleId,
        createPerfectStore = false,
    ) => {
        try {
            const forms = await schedulesServices.getFormsByIds(formsIds)

            // forms a sumar
            const formsWeigh = forms
                .map((form) => {
                    return {
                        form_id: form._id,
                        weigh: form.weigh || null,
                    }
                })
                .filter((form) => form.weigh !== null)

            const formsIdsWeigh = formsWeigh.map((form) => form.form_id)

            // forms progres realizados
            const fqa = await schedulesServices.getFQAByStore(
                formsIdsWeigh,
                storeId,
                scheduleId,
            )

            const formsRealized = fqa.map((form) => {
                return {
                    form_id: form.form_id,
                    form_name: form.form_name,
                    progress: form.progress_questions_yes_na || 0,
                    status_send: form.status_send || 0,
                }
            })

            const formsFinal = formsRealized.map((form) => {
                const formWeighObj = formsWeigh.find(
                    (f) => f.form_id === form.form_id,
                )

                return {
                    form_id: form.form_id,
                    form_name: form.form_name,
                    progress: form.progress,
                    status_send: form.status_send,
                    weigh: formWeighObj ? formWeighObj.weigh : null,
                }
            })

            let PS = formsFinal.reduce((acc, f) => {
                const score = Number(f.progress) || 0
                const weigh = f.weigh.toString().includes('.')
                    ? Number(f.weigh)
                    : Number(`0.${f.weigh}`)
                return acc + (isNaN(weigh) ? 0 : score * weigh)
            }, 0)
            // Redondear PS a 0 decimales si es exactamente 100, sino dejar como está
            console.log('PS BEFORE=======> ', PS)

            if (PS > 100) {
                PS = 100
            } else {
                PS = parseFloat(PS.toFixed(2))
            }
            console.log('PS =======> ', PS)

            // ✅ Obtener KPIs existentes
            const existingKPIs = await schedulesServices.getStoreKPIS(storeId)

            let updatedKPIs = []

            if (createPerfectStore) {
                // ✅ Buscar si ya existe el KPI de Perfect Store
                const psIndex = existingKPIs.findIndex(
                    (kpi) => kpi.kpi === 'Perfect Store',
                )

                const perfectStoreKPI = {
                    kpi: 'Perfect Store',
                    value: PS,
                    index: 0, // ✅ Perfect Store siempre tiene index 0
                    type: 'percentage',
                    criticalMomentCode: '-',
                }

                if (psIndex !== -1) {
                    // ✅ Actualizar Perfect Store existente
                    updatedKPIs = [...existingKPIs]
                    updatedKPIs[psIndex] = perfectStoreKPI
                    console.log('✅ Perfect Store actualizado en KPIs existentes')
                } else {
                    // ✅ Agregar Perfect Store a los KPIs existentes
                    updatedKPIs = [perfectStoreKPI, ...existingKPIs]
                    console.log('✅ Perfect Store agregado a KPIs existentes')
                }
            } else {
                updatedKPIs = [...existingKPIs]
                console.log('ℹ️ Perfect Store NO será creado/actualizado')
            }

            // ✅ Validar que todos los KPIs tengan index
            updatedKPIs = updatedKPIs.map((kpi, idx) => {
                if (kpi.index === undefined || kpi.index === null) {
                    console.warn(
                        `⚠️ KPI sin index: ${kpi.kpi}, se asignará ${idx + 1}`,
                    )
                    return { ...kpi, index: idx + 1 }
                }
                return kpi
            })

            // ✅ Ordenar por index antes de guardar
            updatedKPIs.sort((a, b) => a.index - b.index)

            await schedulesServices.updateStoreKPIS(storeId, updatedKPIs)
            console.log('✅ KPIs guardados correctamente:', updatedKPIs.length)
            setKpis(orderKPIsWithPerfectStoreFirst(updatedKPIs))
            return
        } catch (error) {
            console.error('Error en generateKpiForms:', error)
            return
        }
    }

    const getCheckinId = async (checkinIdToSend: any) => {
        if (isValidMongoId(checkinIdToSend)) {
            return checkinIdToSend
        }
        let dataCheckinID = checkinIdToSend
        // let dataCheckinIDLocal = ''
        const dataCheckin = await schedulesServices.get_checkin(storeID, scheduleID)

        if (dataCheckin) {
            const index = dataCheckin.length - 1
            // dataCheckinIDLocal = dataCheckin[index]._id
            dataCheckinID = dataCheckin[index].checkin_id
        } else {
            //alert(No se encontra el checkin.)
            alert(languageFile.no_checkin_found)
            return
        }
        return dataCheckinID
    }

    /**
     * @description llama a las funciones de validacion de forms, en caso de que pase las valiaciones ejecuta la funcion checkout
     */
    const validates_forms = async () => {
        try {
            setLoadingCheckout(true)
            const validate = await validate_forms_relevant() //aca valido si realizo los forms obligatorios
            // console.log('1704 --  constvalidates_forms= ~ validate:', validate)

            if (validate.status === 1) {
                // si no tengo obligatorios, verifico si tengo pendientes..
                let view_modal = false
                let data = {
                    title: 'Tienes acciones pendientes antes de finalizar',
                    message: '',
                    form_id: null,
                }

                let index = 0

                const validate_forms = validate_forms_in_progress_pending()
                const validate_forms_objective = validate_forms_schedule_objective()

                // const getFormPending = get_names_forms_pendings() // nuevo

                if (validate_forms_objective.status !== 1) {
                    // tengo forms Objectives pendientes entonces muestro modal
                    view_modal = true
                    index = formsContext.findIndex(
                        (formContext) =>
                            formContext._id === validate_forms_objective.form_id,
                    )
                    data.message = data.message.concat(
                        data.message != '' ? '\n' : '',
                        validate_forms_objective.message,
                    )
                }
                if (validate_forms.status !== 1) {
                    // tengo forms en curso entonces muestro modal
                    view_modal = true
                    index = formsContext.findIndex(
                        (formContext) => formContext._id === validate_forms.form_id,
                    )
                    data.message = data.message.concat(
                        data.message != '' ? '\n' : '',
                        validate_forms.message,
                    )
                }

                // if (getFormPending && getFormPending.status !== 1) {
                //     view_modal = true
                //     index = formsContext.findIndex((formContext) => formContext._id === validate_forms_objective.form_id)

                //     setValidateCheckout((prev) => {
                //         return {
                //             isPosibleCheckout: prev.isPosibleCheckout,
                //             messageValidateCheckout: getFormPending.message,
                //         }
                //     })
                // }

                if (view_modal) {
                    await checkOut()

                    // setValidateCheckout((prev) => {
                    //     return {
                    //         isPosibleCheckout: true,
                    //         messageValidateCheckout: prev.messageValidateCheckout,
                    //     }
                    // })

                    // openBottomSheet(
                    //     <GotoForm
                    //         data={data}
                    //         closeBottomSheet={closeBottomSheet}
                    //         navigateToForms={navigateToForms}
                    //         indexForm={index}
                    //         title={data.title}
                    //         button
                    //         checkOut={() => checkOut()}
                    //     />,
                    // )
                } else {
                    await checkOut()
                    // confirmCheckOut() // MODAL CONFIRM CHECKOUT
                }
            } else {
                let view_model = false
                let message = ''
                // si me faltan completar formularios obligatorios, muestro el modal
                // alert(validate.message)
                let index = formsContext.findIndex(
                    (formContext) => formContext._id === validate.form_id,
                )

                if (index != -1) {
                    const form = formsContext[index]

                    const form_name = form['name_form']

                    if (form_name != null && form_name != undefined) {
                        message = `⚠️ Obligatorio: ${form_name}`
                        view_model = true
                    }
                }
                if (isUserBlocked()) {
                    // console.log('1120 ---- isUserBlocked: ', isUserBlocked())
                    console.log(
                        '1121 --- estoy en periodo de moderacion y tengo forms obligatorios',
                    )
                    // si estoy en periodo de moderacion y tengo forms obligatorios, debo dejar hacer checkout
                    await checkOut()
                    return
                }

                if (view_model) {
                    setValidateCheckout({
                        isPosibleCheckout: true,
                        messageValidateCheckout: message,
                    })
                }

                // let title = languageFile.checkout_blocked
                // const snapPoints = ['40%']
                // const indexForm = formsContext.findIndex((formContext) => formContext._id === validate.form_id)
                // console.log('formContext.length => ', formsContext.length)
                // const form = formsContext.find((formContext) => formContext._id === validate.form_id)

                // openBottomSheet(
                //     <GotoForm
                //         data={validate}
                //         title={title}
                //         closeBottomSheet={closeBottomSheet}
                //         navigateToForms={navigateToForms}
                //         indexForm={indexForm}
                //     />,
                // )
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingCheckout(false)
        }
    }

    const confirmCheckOut = async () => {
        const snapPoints = [fontScale > 1 ? '75%' : '55%']

        const title = languageFile.want_to_check_out
        const description = languageFile.not_check_in_again
        const buttonConfirm = languageFile.confirm
        const buttonCancel = languageFile.cancel

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/stores/existingStore.png')}
                title={title}
                desc={description}
                button={buttonCancel}
                closeBottomSheet={closeBottomSheet}
                buttonGoto={buttonConfirm}
                goto={checkOut}
            />,
            snapPoints,
        )
    }

    const checkLocationFn = async () => {
        try {
            setStartAnimationLoaderUbi(true)
            await checkLocation()
        } catch (error) {
            console.error('checkLocationFn error:', error)
        } finally {
            setStartAnimationLoaderUbi(false)
        }
    }

    const renderButtonStore = useCallback(() => {
        switch (statusCheckin) {
            case CHECKIN_PENDIENTE:
                return (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity
                            onPress={() => checkIn()}
                            style={styles.checkInOutButton}
                            disabled={loadingCheckin}
                        >
                            {loadingCheckin ? (
                                <ActivityIndicator
                                    size='small'
                                    color={'white'}
                                    style={styles.marginLeftIcon}
                                />
                            ) : (
                                <Text style={styles.mainButtonText}>
                                    {languageFile.check_in}
                                </Text>
                            )}
                        </TouchableOpacity>
                        {validateCheckin.isPosibleCheckin && (
                            <View
                                style={{
                                    marginTop: 10,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Text
                                    style={{
                                        color: 'yellow',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {validateCheckin.messageValidateCheckin}
                                </Text>

                                <View style={{ marginHorizontal: 5 }} />

                                <TouchableOpacity
                                    style={stylesSchedules.iconButton}
                                    onPress={checkLocationFn}
                                >
                                    <Animated.View
                                        style={{
                                            transform: [{ rotate: spinRefreshUbi }],
                                        }}
                                    >
                                        <Feather
                                            name='refresh-ccw'
                                            size={iconSize}
                                            color={theme.colors.background}
                                        />
                                    </Animated.View>
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                )
            case CHECKIN_REALIZADO:
                return (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity
                            onPress={() => validates_forms()}
                            style={styles.checkInOutButtonBis}
                            disabled={loadingCheckout}
                        >
                            {loadingCheckout ? (
                                <ActivityIndicator
                                    size='small'
                                    color={theme.colors.colorPrimary}
                                    style={styles.marginLeftIcon}
                                />
                            ) : (
                                <Text style={styles.mainButtonTextActive}>
                                    {languageFile.check_out}
                                </Text>
                            )}
                        </TouchableOpacity>
                        {validateCheckout.isPosibleCheckout && (
                            <View style={{ marginTop: 10 }}>
                                <Text
                                    style={{
                                        color: 'yellow',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        paddingTop: 8,
                                        paddingBottom: 5,
                                    }}
                                >
                                    {validateCheckout.messageValidateCheckout}
                                </Text>
                            </View>
                        )}
                    </View>
                )
            case CHECKOUT_REALIZADO:
                return (
                    <LinearGradient
                        style={styles.linearGradient}
                        colors={[
                            theme.colors.colorPrimary,
                            theme.colors.linearGradientStart,
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                    >
                        <Text style={styles.mainButtonText}>
                            {languageFile.check_out_done}
                        </Text>
                        <Feather
                            name='check'
                            size={iconSizeMin}
                            color={'white'}
                            style={styles.marginLeftIcon}
                        />
                    </LinearGradient>
                )

            case 4:
                return (
                    <LinearGradient
                        style={styles.linearGradient}
                        colors={[
                            theme.colors.colorPrimary,
                            theme.colors.linearGradientStart,
                        ]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                    >
                        <Text style={styles.mainButtonText}>
                            {languageFile.off_route}
                        </Text>
                        <Feather
                            name='x'
                            size={16}
                            color={'white'}
                            style={styles.marginLeftIcon}
                        />
                    </LinearGradient>
                )
            default:
        }
    }, [
        statusCheckin,
        formsContext,
        loadingCheckin,
        loadingCheckout,
        validateCheckout.isPosibleCheckout,
        validateCheckin.isPosibleCheckin,
        lastUpdateCoorsUser,
    ])

    /**
     * @description updateo el status de los formularios de formsContext y de la tabla SCHEDULES_STORE_NAMES.FORMS por el status que recibo por param
     * @param status number
     */
    /**
     * ✅ Ejecuta operaciones de BD de forma serializada para evitar "database is locked"
     */
    const executeDbOperation = async <T,>(
        operation: () => Promise<T>,
    ): Promise<T> => {
        // Encolar la operación si hay otra en progreso
        return new Promise((resolve, reject) => {
            const wrappedOperation = async () => {
                dbOperationInProgressRef.current = true
                try {
                    const result = await operation()
                    resolve(result)
                } catch (error) {
                    reject(error)
                } finally {
                    dbOperationInProgressRef.current = false
                    // Procesar siguiente operación en cola
                    const nextOperation = dbOperationQueueRef.current.shift()
                    if (nextOperation) {
                        nextOperation()
                    }
                }
            }

            if (dbOperationInProgressRef.current) {
                // Hay una operación en progreso, encolar esta
                console.log(
                    '⏳ [executeDbOperation] Operación encolada - hay otra en progreso',
                )
                dbOperationQueueRef.current.push(wrappedOperation)
            } else {
                // No hay operaciones en progreso, ejecutar inmediatamente
                wrappedOperation()
            }
        })
    }

    /**
     * ✅ Retry helper para operaciones que pueden fallar con "database is locked"
     */
    const retryDbOperation = async <T,>(
        operation: () => Promise<T>,
        maxRetries = 3,
        delayMs = 100,
    ): Promise<T> => {
        let lastError: any
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                return await operation()
            } catch (error) {
                lastError = error
                const errorMessage = error?.message || String(error)
                if (
                    errorMessage.includes('database is locked') &&
                    attempt < maxRetries
                ) {
                    console.warn(
                        `⚠️ [retryDbOperation] Intento ${attempt}/${maxRetries} falló - reintentando en ${delayMs}ms...`,
                    )
                    await new Promise((resolve) =>
                        setTimeout(resolve, delayMs * attempt),
                    )
                    continue
                }
                throw error
            }
        }
        throw lastError
    }

    const updateStatusForms = async (status: number) => {
        try {
            // ✅ FIX: Excluir también PENDING_CONNECTION (formularios completados offline esperando sincronización)
            const formsNoCompleted = formsContext.filter(
                (form) =>
                    form.status !== FORM_SCHEDULE_STATUS.COMPLETED &&
                    form.status !== FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )

            console.log('🔄 [updateStatusForms] Actualizando formularios:', {
                targetStatus: status,
                totalForms: formsContext.length,
                formsToUpdate: formsNoCompleted.length,
                preservingCompleted: formsContext.filter(
                    (f) => f.status === FORM_SCHEDULE_STATUS.COMPLETED,
                ).length,
                preservingPendingConnection: formsContext.filter(
                    (f) => f.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                ).length,
            })

            // ✅ FIX: Preservar COMPLETED, PENDING_CONNECTION e IN_PROGRESS
            // No sobrescribir formularios que ya están completados o esperando sincronización
            // ✅ SPECIAL CASE: Formularios de heladera en IN_PROGRESS pasan a COMPLETED en checkout
            console.log('setFormsContext 3')
            setFormsContext((prevForms) =>
                prevForms.map((form: FormProps) => {
                    // ✅ Caso especial: Heladera en progreso durante checkout → completar
                    if (
                        form.type_form.type === FORM_TYPES.FORM_POP_HELADERA &&
                        form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS &&
                        status === FORM_SCHEDULE_STATUS.BLOCKED
                    ) {
                        console.log(
                            `✅ [updateStatusForms] Heladera "${form.name_form}" en progreso → COMPLETADO (checkout)`,
                        )
                        return { ...form, status: FORM_SCHEDULE_STATUS.COMPLETED }
                    }

                    return {
                        ...form,
                        status:
                            form.status === FORM_SCHEDULE_STATUS.COMPLETED
                                ? form.status // ✅ Preservar completados
                                : form.status ===
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                  ? form.status // ✅ Preservar completados offline (amarillo)
                                  : form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS
                                    ? form.status // ✅ Preservar en progreso
                                    : status == FORM_SCHEDULE_STATUS.BLOCKED &&
                                        form.type_form.type ==
                                            FORM_TYPES.FORM_MODERACION
                                      ? form.status
                                      : status,
                    }
                }),
            )
            console.log(
                '✅ [updateStatusForms] formsContext UI actualizado - esperando propagación...',
            )

            // ✅ CRÍTICO: Dar tiempo a React para propagar el nuevo estado antes de triggers
            // Esto evita que componentes hijos lean el valor viejo y sobreescriban el cambio
            await new Promise((resolve) => setTimeout(resolve, 50))

            // ❌ NO llamar setReloadChange() aquí - causa race condition
            // Los componentes se actualizarán automáticamente cuando React propague el nuevo formsContext

            // ✅ Actualizar BD de forma serializada con retry logic (en paralelo con React)
            await executeDbOperation(async () => {
                console.log(
                    '💾 [updateStatusForms] Iniciando actualización de BD...',
                )
                for (const form of formsNoCompleted) {
                    // ✅ CASO ESPECIAL: Heladera en IN_PROGRESS durante checkout → pasar a COMPLETED
                    if (
                        form.type_form.type === FORM_TYPES.FORM_POP_HELADERA &&
                        form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS &&
                        status === FORM_SCHEDULE_STATUS.BLOCKED
                    ) {
                        console.log(
                            `✅ [updateStatusForms BD] Heladera "${form.name_form}" en progreso → COMPLETADO en BD`,
                        )
                        await retryDbOperation(async () => {
                            await schedulesServices.updateStatusFormAnswerSchedule(
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                scheduleID,
                                form._id,
                                storeID,
                                'heladera completada',
                                null,
                                checkInID //checkinID,
                            )
                        })
                        continue
                    }

                    // ✅ FIX: No actualizar formularios completados o esperando sincronización
                    if (form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS) {
                        console.log(
                            `⏭️ [updateStatusForms] Saltando ${form.name_form} - ya está EN CURSO`,
                        )
                        continue
                    }
                    if (form.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) {
                        console.log(
                            `⏭️ [updateStatusForms] Saltando ${form.name_form} - esperando sincronización (amarillo)`,
                        )
                        continue
                    }
                    if (form.status === FORM_SCHEDULE_STATUS.COMPLETED) {
                        console.log(
                            `⏭️ [updateStatusForms] Saltando ${form.name_form} - ya está COMPLETADO`,
                        )
                        continue
                    }

                    let updateStatus = status
                    if (
                        updateStatus == FORM_SCHEDULE_STATUS.BLOCKED &&
                        form.type_form.type == FORM_TYPES.FORM_MODERACION
                    ) {
                        updateStatus = form.status
                    }

                    // Retry para cada actualización individual
                    await retryDbOperation(async () => {
                        await schedulesServices.updateStatusFormAnswerSchedule(
                            updateStatus,
                            scheduleID,
                            form._id,
                            storeID,
                            'updateStatusForms',
                            null,
                            checkInID,
                        )
                    })
                }
                console.log('✅ [updateStatusForms] BD actualizada correctamente')
            })
        } catch (error) {
            console.error('❌ [updateStatusForms] ERROR:', error)
            // No lanzar el error para evitar romper el flujo del check-in
            // El estado en UI ya está actualizado, el error es solo en BD
        }
    }

    const handleClickSet = (item: FormProps, index: number) => {
        if (item.status === FORM_SCHEDULE_STATUS.COMPLETED && !item.repeat) {
            return () => {}
        } else {
            return navigateToForms(
                item._id || item.name_form || index,
                item.name_form,
            )
        }
    }

    const openMap = () => {
        const scheme = platformSelect({
            ios: 'maps://0,0?q=',
            android: 'geo:0,0?q=',
        })
        const latLng = `${store.lat},${store.lng}`
        const label = store.name ?? languageFile.selected_store
        const url = platformSelect({
            ios: `${scheme}${label}@${latLng}`,
            android: `${scheme}${latLng}(${label})`,
        })
        //GoogleMaps iOS  // const browser_url = 'https://www.google.de/maps/@' + store.lat + ',' + store.lng + '?q=' + label
        Linking.openURL(url)
    }

    const updateVoucher = (item) => {
        const updatedVouchers = vouchers.map((voucher) =>
            voucher._id === item._id ? item : voucher,
        )
        setVouchers(updatedVouchers)
    }

    const updateStatusStoreAndCreateAdvance = async (
        status: number,
        textAnswer: string,
    ) => {
        try {
            const objetives = await createObjetives()

            await schedulesServices.upsertScheduleAdvanceLocal(
                scheduleID,
                storeID,
                status,
                new Date().toISOString(),
                [],
                objetives,
                textAnswer,
            )

            await schedulesServices.update_status_store(
                storeID,
                scheduleID,
                status,
                new Date().toISOString(),
            )

            updateStoreStatus(storeID, status)
        } catch (error) {
            console.error('updateStatusStoreAndCreateAdvance => ', error)
        }
    }
    const createObjetives = async () => {
        let objetives = []
        try {
            let schedule = await schedulesServices.get_schedule(scheduleID)
            if (
                schedule &&
                schedule.additional &&
                schedule.additional.objective &&
                schedule.additional.objective.length > 0 &&
                schedule.additional.objective.some(
                    (item) =>
                        item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP,
                )
            ) {
                let steps_group_forms = schedule.additional.objective.find(
                    (item) =>
                        item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP,
                )
                if (
                    steps_group_forms &&
                    steps_group_forms.form.length > 0 &&
                    steps_group_forms.name_required.length > 0
                ) {
                    let get_names_forms = await schedulesServices.get_name_forms(
                        steps_group_forms.name_required,
                        steps_group_forms.form,
                        forms,
                    )
                    objetives = Array.isArray(get_names_forms) ? get_names_forms : []
                }
            }
        } catch (error) {
            console.error('createObjetives => ', error)
        } finally {
            return objetives
        }
    }
    const actionButonSendIncidence = async (
        statusIncidence: number,
        incidenteResponse: string,
    ) => {
        try {
            setIsIncidenceReport(true)
            closeBottomSheet(true)
            if (statusIncidence != null && incidenteResponse != null) {
                setStatus_store(statusIncidence)
                await updateStatusStoreAndCreateAdvance(
                    statusIncidence,
                    incidenteResponse,
                )
                setButtonIncidenceText(incidenteResponse)
                navigation.goBack()
            }
        } catch (error) {
            console.error('🚀 ~ actionButonSendIncidence ~ error', error)
        }
    }

    const handleNotifyIncident = async () => {
        try {
            let { status, store, schedule_advances } =
                await schedulesServices.validateCheckins(scheduleID)

            console.log('🚀 ~ checkIn ~ status:', status, schedule_advances)
            //valido fechaa
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)

            let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

            console.log(
                status,
                '-----------fecha de hoyyy ~ fecha_hoy:',
                fecha_hoy_str,
                schedule_advances,
            )

            if (
                !status &&
                schedule_advances &&
                schedule_advances.date_init < fecha_hoy_str
            ) {
                console.log(
                    '-----------esta vencidoo~ fecha_hoy:',
                    fecha_hoy_str,
                    schedule_advances.date_init,
                )
                status = true
            }
            if (!status) {
                let title = 'Incidencia bloqueada'
                let desc = languageFile.close_the_open_checkin
                let button = languageFile.accept

                if (store && store.name && store.code) {
                    desc =
                        languageFile.close_the_checkin_opened_in +
                        `${store.name}, ${store.code}`
                }

                return openBottomSheet(
                    <BottomSheetAlert
                        image={require('../../../assets/stores/checkinLocked.png')}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={closeBottomSheet}
                    />,
                    ['50%'],
                )
            }
        } catch (error) {
            console.error('🚀 ~ handleNotifyIncident ~ error', error)
        }
        const cordUser = {
            lat: userLat,
            lng: userLng,
            last_update_coords: lastUpdateCoorsUser,
        }
        const canValidateDistance = validateUpdateCoordsTime(lastUpdateCoorsUser)

        const isValidDistanceCheckin =
            await schedulesServices.isValidDistanceCheckin(storeID, cordUser)

        if (!isValidDistanceCheckin && canValidateDistance) {
            setValidateCheckin({
                isPosibleCheckin: true,
                messageValidateCheckin: '🚫 Estás fuera de los 50mts.',
            })
            return
        }

        if (formIncidence) {
            openBottomSheet(
                <View style={{ flex: 1 }}>
                    <Image
                        style={[
                            stylesScheduleDistributor.image,
                            { alignSelf: 'center' },
                        ]}
                        source={require('../../../assets/reportIncident.png')}
                    />

                    <FormView
                        key={formIncidence?._id}
                        formContent={formIncidence?.contents || []}
                        // hideOrShow={hideOrShow}
                        hideOrShow={() => {}}
                        form_id={formIncidence?._id}
                        store_id={storeID}
                        schedule_id={scheduleID}
                        repeat={formIncidence?.repeat}
                        progress={formIncidence?.progress}
                        totalScore={formIncidence?.totalScore}
                        clearRegisterDatabaseLocal={null}
                        hasFinishSheet={false}
                        reloadHideShowData={null}
                        tags={[]}
                        onClickTag={() => {}}
                        formType={formIncidence?.type_form.type}
                        actionButonSend={actionButonSendIncidence}
                        formTypeObj={formIncidence.type_form}
                    />
                    <TouchableOpacity
                        style={[
                            stylesScheduleDistributor.borderButton,
                            {
                                marginTop: -16,
                                borderColor: theme.colors.colorPrimary,
                            },
                        ]}
                        onPress={() => closeBottomSheet(true)}
                    >
                        <Text style={styles.borderButtonText}>Cancelar</Text>
                    </TouchableOpacity>
                    <View style={stylesScheduleDistributor.spacer}></View>
                    <View style={stylesScheduleDistributor.spacer}></View>
                </View>,
            )
        }
    }

    useEffect(() => {
        console.log('useEffect StoreDetail 1')
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(20) // Valor normal
        }

        askAgain()
        loadData()
        setStoreStatus(storeID, status_store)

        return () => {
            setFormsContext([])
            // ✅ Limpiar form de incidencia al desmontar para evitar que persista entre tiendas
            // clearDataFormIncidence() // se limpia al cerrar session, no aca porque este state se carga solamente cuando descarga la agenda
        }
    }, [])

    // ✅ Limpiar formularios cuando cambian storeID o scheduleID
    useEffect(() => {
        // ⚠️ NO recargar si estamos en medio de check-in
        if (isUpdatingFormStatusRef.current) {
            console.log(
                '⚠️ [StoreDetail useEffect storeID] Recarga bloqueada - check-in en progreso',
            )
            return
        }

        console.log(
            '🔄 [StoreDetail useEffect] Cambio detectado - storeID:',
            storeID,
            'scheduleID:',
            scheduleID,
        )
        console.log('🧹 [StoreDetail] Limpiando formsContext...')
        // CRÍTICO: Usar función updater para forzar limpieza y evitar el merge del contexto
        setFormsContext(() => [])
        // ✅ También limpiar el form de incidencia cuando cambias de tienda
        // clearDataFormIncidence()
        console.log('📥 [StoreDetail] Cargando datos para nueva tienda...')
        // Usar loadAllData para cargar local + online de manera coordinada
        loadAllData()

        // Actualizar el ref con el nuevo storeID
        prevStoreIdRef.current = storeID
    }, [storeID, scheduleID])

    useCallback(() => {
        console.log('useEffect StoreDetail 2')
        validateStatusCheckin()
        calculateRelevProgress()
    }, [statusSteps, formsContext])

    useEffect(() => {
        // ⚠️ NO recargar si estamos en medio de check-in
        if (isUpdatingFormStatusRef.current) {
            console.log(
                '⚠️ [StoreDetail useEffect reloadForms] Recarga bloqueada - check-in en progreso',
            )
            return
        }

        console.log('useEffect StoreDetail 3')
        // En recargas, solo actualizar datos local sin mostrar loading principal
        fetchDataLocalNew()
    }, [reloadForms])

    useEffect(() => {
        console.log('useEffect StoreDetail 4')
        if (formsContext.length > 0) {
            let indicators = false
            for (let i = 0; i < formsContext.length; i++) {
                if (formsContext[i].mandatory == true) {
                    indicators = true
                    break
                }
            }
            setShowIndicators(indicators)
        }
    }, [formsContext])

    useEffect(() => {
        console.log('useEffect StoreDetail 5')
        if (navigate_form && formsContext.length > 0) {
            const timer = setTimeout(() => {
                const indexForm = formsContext.findIndex(
                    (formContext) => formContext._id == navigate_form,
                )
                if (indexForm !== -1) {
                    navigateToForms(indexForm)
                }
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [navigate_form && formsContext.length > 0])

    useEffect(() => {
        console.log('useEffect StoreDetail 6')
        const unsubscribeFocus = navigation.addListener('focus', () => {
            setValidateCheckout({
                isPosibleCheckout: false,
                messageValidateCheckout: '',
            })
            setValidateCheckin({
                isPosibleCheckin: false,
                messageValidateCheckin: '',
            })

            // ⚠️ NO recargar si estamos en medio de check-in
            if (isUpdatingFormStatusRef.current) {
                console.log(
                    '⚠️ [StoreDetail focus listener] Recarga bloqueada - check-in en progreso',
                )
                return
            }

            // ✅ Solo recargar formularios si NO cambió el storeID (es decir, vuelve de ExecutionView u otra pantalla)
            // Si cambió el storeID, el useEffect de [storeID, scheduleID] ya se encargará
            // El merge en setFormsContext preservará el status actualizado del contexto
            if (prevStoreIdRef.current === storeID) {
                console.log(
                    '🔄 StoreDetail recibió foco (misma tienda) - recargando formularios locales',
                )
                fetchDataLocalNew()
            }
        })
        return unsubscribeFocus
    }, [navigation, storeID])

    useEffect(() => {
        // ⚠️ NO recargar si estamos en medio de check-in
        if (isUpdatingFormStatusRef.current) {
            console.log(
                '⚠️ [StoreDetail useEffect reloadForms online] Recarga bloqueada - check-in en progreso',
            )
            return
        }

        console.log('useEffect reloadForms triggered')
        // Solo actualizar datos online, sin loading
        if (initialLoadComplete) {
            fetchDataOnlineNew()
        }
    }, [reloadForms])

    const getFreq = () => {
        let freq = ''
        if (!store) return freq
        if (store.frequency && store.frequency != '') {
            freq = store.frequency
            return freq
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'frequencia')
            if (value && value != undefined) {
                freq = value.value
                return freq
            }
        }
        return freq
    }
    const getTopStore = () => {
        let top = ''
        if (!store) return top
        if (store.topstore && store.topstore != '') {
            top = store.topstore
            return top
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'topstore')
            if (value && value != undefined) {
                top = value.value
                return top
            }
        }
        return top
    }
    const getPotencial = () => {
        let pot = ''
        if (!store) return pot
        if (store.potencial && store.potencial != '') {
            pot = store.potencial
            return pot
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'potencial')
            if (value && value != undefined) {
                pot = value.value
                return pot
            }
        }
        return pot
    }
    const frequency = getFreq()
    const topStore = getTopStore()
    const potencial = getPotencial()
    const RenderIndicence = useMemo(() => {
        if (isIncidenceReport) {
            return (
                <View style={stylesCampaingView.containerStoreClose}>
                    <MaterialCommunityIcons
                        name='store-alert-outline'
                        size={24}
                        color='white'
                    />
                    <Text
                        style={[
                            {
                                marginLeft: 8,
                                marginTop: 1,
                                color: 'white',
                                fontWeight: '700',
                            },
                        ]}
                    >
                        {buttonIncidenceText}
                    </Text>
                </View>
            )
        }

        return <></>
    }, [isIncidenceReport, status_store, buttonIncidenceText])

    const RenderNotifyIndicence = useMemo(() => {
        if (canFormIncidence && formIncidence) {
            return (
                <TouchableOpacity
                    style={[
                        styles.checkInOutButton,
                        {
                            backgroundColor: 'rgba(0, 0, 0, 0.2)',
                            marginHorizontal: 0,
                            marginRight: 10,
                            maxHeight: 45,
                        },
                    ]}
                    onPress={() => handleNotifyIncident()}
                >
                    <Image
                        style={{ width: 20, height: 20 }}
                        source={require('../../../assets/icon_incidencia.png')}
                    />
                </TouchableOpacity>
            )
        }
        return null
    }, [canFormIncidence, formIncidence])
    const [kpis, setKpis] = useState<any[]>([])

    // Actualizo KPI cuando llegan nueva data via zustand
    useEffect(() => {
        if (!latestKpisFromForms || latestKpisFromForms.length === 0) return

        setKpis((currentKpis) => {
            const merged = [...currentKpis]
            let hasChanges = false

            for (const incoming of latestKpisFromForms) {
                const existingIdx = merged.findIndex((k) => k.kpi === incoming.kpi)
                if (existingIdx !== -1) {
                    if (merged[existingIdx].value !== incoming.value) {
                        merged[existingIdx] = incoming
                        hasChanges = true
                    }
                } else {
                    merged.push(incoming)
                    hasChanges = true
                }
            }

            if (!hasChanges) return currentKpis

            const ordered = orderKPIsWithPerfectStoreFirst(merged)
            schedulesServices.updateStoreKPIS(storeID, ordered)
            return ordered
        })
    }, [latestKpisFromForms])

    // Actualizar status de formularios cuando llegan respuestas de envio (amarillo -> verde)
    useEffect(() => {
        if (!sentFormsForStore || Object.keys(sentFormsForStore).length === 0) return

        // Usar updater function para: 1) leer siempre el state más reciente,
        // 2) bypasear el merge de setFormsContext que preserva el status viejo.
        setFormsContext((prevForms: FormProps[]) => {
            let hasChanges = false
            const updatedForms = prevForms.map((form) => {
                const sentStatus = sentFormsForStore[form._id]
                // console.log(
                //     '🔄 Revisando formulario',
                //     form.name_form,
                //     'status actual:',
                //     form.status,
                //     'status enviado:',
                //     sentStatus,
                // )
                if (sentStatus !== undefined && form.status !== sentStatus) {
                    hasChanges = true
                    return { ...form, status: sentStatus }
                }
                return form
            })

            if (hasChanges) {
                console.log(
                    '✅ Actualizando formsContext con nuevos status de envío',
                )
                return updatedForms
            }
            return prevForms
        })
    }, [sentFormsForStore])

    /**
     * ✅ Ordena los KPIs asegurando que "Perfect Store" aparezca primero
     */
    const orderKPIsWithPerfectStoreFirst = (kpis: any[]) => {
        if (!kpis || kpis.length === 0) return []

        const perfectStoreIndex = kpis.findIndex(
            (kpi) => kpi.kpi && kpi.kpi.trim().toUpperCase() === 'PERFECT STORE',
        )

        // Si existe Perfect Store, lo ponemos primero con index -1
        if (perfectStoreIndex !== -1) {
            const perfectStore = { ...kpis[perfectStoreIndex], index: -1 }
            const otherKpis = kpis
                .filter((_, idx) => idx !== perfectStoreIndex)
                .map((kpi, idx) => ({
                    ...kpi,
                    index:
                        kpi.index !== undefined && kpi.index !== null
                            ? kpi.index
                            : idx,
                }))

            return [perfectStore, ...otherKpis]
        }

        // Si no existe Perfect Store, retornar los KPIs con sus índices validados
        return kpis.map((kpi, idx) => ({
            ...kpi,
            index: kpi.index !== undefined && kpi.index !== null ? kpi.index : idx,
        }))
    }

    const getIndicators = (
        forms: FormProps[],
        kpis: KpisIndicators[],
    ): Array<FormProps | any> => {
        try {
            let indicators: Array<FormProps | KpisIndicators> = []
            // ✅ primero kpis
            if (kpis && kpis.length > 0) {
                let mapKpis = kpis
                    .map((kpi, idx) => {
                        let _id = Math.random().toString(36).substring(2, 15) // Genera un ID único aleatorio

                        // Mantener el índice original de los KPIs
                        const kpiIndex = kpi.index ?? idx

                        return {
                            ...kpi,
                            _id: _id,
                            isKPI: true,
                            index: kpiIndex,
                        }
                    })
                    .sort((a, b) => a.index - b.index) // Ordenar KPIs por su index

                // console.log('Cantidad de KPIS:', mapKpis.length)
                // console.log('KPIS', mapKpis)
                indicators = indicators.concat(mapKpis)
            }

            // segundo forms
            if (forms && forms.length > 0) {
                let mandatoryForms = forms
                    .filter((form) => form.mandatory == true)
                    .map((form) => ({
                        ...form,
                        index: (form as any).index_form ?? 999,
                        isKPI: false,
                    }))
                    .sort((a, b) => (a.index ?? 999) - (b.index ?? 999)) // Ordenar forms por su index

                if (mandatoryForms && mandatoryForms.length > 0) {
                    // Sumar offset para que los forms vengan después de los KPIs
                    const formsWithOffset = mandatoryForms.map((form) => ({
                        ...form,
                        index: (form.index ?? 999) + 1000,
                    }))
                    indicators = indicators.concat(formsWithOffset)
                }
            }

            if (indicators.length > 0) {
                setShowIndicators(true)
            }
            const filteredIndicators = filterIndicators(indicators)

            // console.log('Indicadores filtrados:', filteredIndicators)

            return filteredIndicators
        } catch (error) {
            console.error('Error in getIndicators:', error)
            return []
        }
    }

    const filterIndicators = (indicators) => {
        try {
            if (!indicators || indicators.length === 0) return []
            const seen = new Set()
            const result = []

            // Primer loop: Procesar KPIs con deduplicación por fecha
            for (const item of indicators) {
                if (item.isKPI === true) {
                    const name = item.kpi.toUpperCase().trim()

                    if (!seen.has(name)) {
                        seen.add(name)
                        result.push(item)
                    } else {
                        const existingIdx = result.findIndex(
                            (r) =>
                                r.isKPI === true &&
                                r.kpi.toUpperCase().trim() === name,
                        )

                        if (existingIdx !== -1) {
                            const existing = result[existingIdx]
                            const existingDate = existing.created_date
                                ? new Date(existing.created_date).getTime()
                                : 0
                            const currentDate = item.created_date
                                ? new Date(item.created_date).getTime()
                                : 0

                            if (currentDate > existingDate) {
                                // console.log(
                                //     `🔄 [filterIndicators] Reemplazando KPI "${name}" antiguo (${existing.created_date || 'sin fecha'}) por más reciente (${item.created_date || 'sin fecha'})`,
                                // )
                                result[existingIdx] = item
                            }
                        }
                    }
                }
            }

            // Segundo loop: Procesar Forms
            for (const item of indicators) {
                if (item.isKPI !== true) {
                    const name = item.name_form.toUpperCase().trim()
                    if (!seen.has(name)) {
                        seen.add(name)
                        result.push(item)
                    }
                }
            }
            // console.log('result ===> antes de expandir => ', result)

            // Expandir indicadores que tienen scores
            const finalResult = []
            const expandedKPIs = []

            for (const item of result) {
                // Verificar si tiene scores (solo en forms, no en KPIs puros)
                if (item.scores && item.isKPI === false) {
                    try {
                        const scoresArray =
                            typeof item.scores === 'string'
                                ? JSON.parse(item.scores)
                                : item.scores

                        if (Array.isArray(scoresArray) && scoresArray.length > 0) {
                            // console.log(
                            //     `📊 [filterIndicators] Expandiendo "${item.name_form}" con ${scoresArray.length} scores`,
                            // )

                            // Crear un KPI por cada score
                            for (const score of scoresArray) {
                                const newKPI = {
                                    _id: `${item._id}_${score.key}`,
                                    isKPI: true,
                                    kpi: score.name,
                                    value: -1, // score.value
                                    scoreForm: String(score.value),
                                    type: 'percentage',
                                    index: score.index,
                                    created_date:
                                        item.created_date ||
                                        new Date().toISOString(),
                                    monthOverMonthChangeFormatted: '-',
                                    monthOverMonthPercentChange: '-',
                                    criticalMomentCode: null,
                                }
                                expandedKPIs.push(newKPI)
                            }

                            // NO agregar el item original
                            // console.log(
                            //     `🗑️ [filterIndicators] Eliminando "${item.name_form}" (reemplazado por scores)`,
                            // )
                            continue
                        }
                    } catch (error) {
                        console.error(
                            `❌ Error parseando scores de "${item.name_form}":`,
                            error,
                        )
                        finalResult.push(item)
                        continue
                    }
                }

                // Agregar items sin scores o con scores vacío
                finalResult.push(item)
            }

            // Combinar resultados + KPIs expandidos
            const combined = [...finalResult, ...expandedKPIs]

            // Deduplicación final (KPIs expandidos pueden duplicar nombres existentes)
            const seenFinal = new Set()
            const deduplicated = []

            for (const item of combined) {
                if (item.isKPI === true) {
                    const name = item.kpi.toUpperCase().trim()

                    if (!seenFinal.has(name)) {
                        seenFinal.add(name)
                        deduplicated.push(item)
                    } else {
                        const existingIdx = deduplicated.findIndex(
                            (r) =>
                                r.isKPI === true &&
                                r.kpi.toUpperCase().trim() === name,
                        )

                        if (existingIdx !== -1) {
                            const existing = deduplicated[existingIdx]
                            const isExistingFromService = existing.value !== -1
                            const isCurrentFromService = item.value !== -1

                            // Si el existente es del servicio y el actual es expandido, mantener el del servicio
                            if (isExistingFromService && !isCurrentFromService) {
                                // console.log(
                                //     `[filterIndicators] Manteniendo KPI del servicio "${name}" (ignorando expandido)`,
                                // )
                                continue
                            }

                            // Si el existente es expandido y el actual es del servicio, reemplazar
                            if (!isExistingFromService && isCurrentFromService) {
                                // console.log(
                                //     `[filterIndicators] Reemplazando KPI expandido "${name}" con del servicio`,
                                // )
                                deduplicated[existingIdx] = item
                                continue
                            }

                            // Si ambos son del mismo origen, comparar por fecha
                            const existingDate = existing.created_date
                                ? new Date(existing.created_date).getTime()
                                : 0
                            const currentDate = item.created_date
                                ? new Date(item.created_date).getTime()
                                : 0

                            if (currentDate > existingDate) {
                                // console.log(
                                //     `[filterIndicators] Reemplazando KPI "${name}" por más reciente`,
                                // )
                                deduplicated[existingIdx] = item
                            }
                        }
                    }
                } else {
                    const name = item.name_form.toUpperCase().trim()
                    if (!seenFinal.has(name)) {
                        seenFinal.add(name)
                        deduplicated.push(item)
                    }
                }
            }

            // console.log(`[filterIndicators] Final: ${deduplicated.length} indicadores (${expandedKPIs.length} expandidos desde forms)`)
            
            const filteredByDate = filterByDate(deduplicated)

            filteredByDate.sort((a, b) => {
                const aValue = a.isKPI === false && a.index_form !== undefined 
                    ? a.index_form 
                    : (a.index !== undefined ? a.index : 999999)
                
                const bValue = b.isKPI === false && b.index_form !== undefined 
                    ? b.index_form 
                    : (b.index !== undefined ? b.index : 999999)
                
                return aValue - bValue
            })
        
            return filteredByDate
        } catch (error) {
            console.error('Error in filterIndicators:', error)
            return indicators || []
        }
    }

    const filterByDate = (indicators) => {
        // Filtro solamente si llega la key date_init y date_finish
        try {
            if (!indicators || indicators.length === 0) return []
            
            const result = []
            const now = new Date()

            for (const item of indicators) {
                // Si tiene date_init y es una fecha futura, no incluir (aún no empezó)
                if (item.date_init && new Date(item.date_init) > now) {
                    continue
                }

                // Si tiene date_finish y es una fecha pasada, no incluir (ya terminó)
                if (item.date_finish && new Date(item.date_finish) < now) {
                    continue
                }

                // Si no tiene fechas o las fechas son válidas, incluir el item
                result.push(item)
            }

            return result
        } catch (error) {
            console.error('Error in filterByDate:', error)
            return indicators
        }
    }

    const indicatorsMemoized = useMemo(
        () => getIndicators(formsContext, kpis),
        [formsContext, kpis],
    )
    function getIndicatorsHeight(indicators) {
        let height = 135 // Alto contemplando kpis
        if (indicators.length === 0) return height
        const hasKpis = indicators.some((indicator) => indicator.isKPI === true)
        if (!hasKpis) height = 135
        return height
    }
    const indicatorsHeight = getIndicatorsHeight(indicatorsMemoized)

    // Memoizar Perfect Store para evitar re-renders innecesarios
    const perfectStoreArrayMemoized = useMemo(
        () => perfectStoreArray,
        [perfectStoreArray],
    )

    // Determinar si mostrar loader de Perfect Store de forma memoizada
    // Solo mostrar loader durante la carga inicial, no en actualizaciones posteriores
    const showPerfectStoreLoader = useMemo(
        () => !initialLoadComplete && isLoadingPerfectStore && hasShowProgress(),
        [isLoadingPerfectStore, initialLoadComplete],
    )

    // Determinar si mostrar loader de Ejecución de forma memoizada
    // Solo mostrar loader durante la carga inicial, no en actualizaciones posteriores
    const showExecutionLoader = useMemo(
        () => !initialLoadComplete && loadingExecution,
        [loadingExecution, initialLoadComplete],
    )
    function renderIndicators() {
        let sectionTitle = languageFile.store_indicators
        let sectionDesc = languageFile.main_indicators
        if (expoConfig.slug === 'savencia-one') {
            sectionTitle = 'Puntaje del último relevamiento'
            sectionDesc =
                'Conoce el puntaje de los indicadores del último relevamiento realizado en la tienda.'
        }
        return (
            <>
                {/* INDICADORES DE TIENDA */}
                {indicatorsMemoized.length > 0 && (
                    <View style={[styles.containerSection, { marginBottom: 20 }]}>
                        <View style={styles.subContainerSection}>
                            <View style={{ flex: 7 }}>
                                <Text style={styles.textSection}>
                                    {sectionTitle}
                                </Text>
                                <Text
                                    style={[
                                        styles.textSectionDescription,
                                        styles.maxWidth,
                                    ]}
                                >
                                    {sectionDesc}
                                </Text>
                                {!showMore && (
                                    <View style={{ marginBottom: 0 }}></View>
                                )}
                            </View>
                            <TouchableOpacity
                                style={{ flex: 1 }}
                                onPress={() => setShowMore(!showMore)}
                            >
                                <Feather
                                    name={!showMore ? 'chevron-down' : 'chevron-up'}
                                    size={iconSize}
                                    color={theme.colors.colorPrimary}
                                />
                            </TouchableOpacity>
                        </View>
                        {showMore && (
                            <FlashList
                                style={{
                                    marginTop: 10,
                                    minHeight: indicatorsHeight,
                                    maxHeight: indicatorsHeight,
                                    marginBottom: 0,
                                }}
                                data={indicatorsMemoized}
                                keyExtractor={(item) => item._id}
                                horizontal={true}
                                nestedScrollEnabled={true}
                                showsHorizontalScrollIndicator={false}
                                renderItem={({ item: item, index }) => (
                                    <View>
                                        {item.isKPI && item.isKPI === true ? (
                                            <StoreKPIIndicators
                                                item={item}
                                                index={index}
                                                onClickItem={() => {
                                                    if (
                                                        statusCheckin ===
                                                        CHECKIN_REALIZADO
                                                    ) {
                                                        console.log(
                                                            '1292 StoreFormButtonsIndicators --- entre aca',
                                                            item.status,
                                                        )
                                                        if (
                                                            item.status !=
                                                                FORM_SCHEDULE_STATUS.COMPLETED &&
                                                            item.status !=
                                                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                                        )
                                                            navigateToForms(
                                                                item._id ||
                                                                    item.name_form ||
                                                                    index,
                                                                item.name_form,
                                                            )
                                                    } else if (
                                                        statusCheckin ===
                                                            CHECKOUT_REALIZADO &&
                                                        item.type_form.type ===
                                                            FORM_TYPES.FORM_MODERACION &&
                                                        item.status ===
                                                            FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION
                                                    ) {
                                                        console.log(
                                                            '1295 StoreFormButtonsIndicators --- entre aca',
                                                        )
                                                        navigateToForms(
                                                            item._id ||
                                                                item.name_form ||
                                                                index,
                                                            item.name_form,
                                                        )
                                                    }
                                                }}
                                            />
                                        ) : (
                                            <StoreFormButtonsIndicators
                                                name={item.name_form}
                                                image={item.icon}
                                                index={index}
                                                // onClickItem={statusCheckin === CHECKIN_REALIZADO ? () => navigateToForms(item._id || index) : () => {}}
                                                onClickItem={() => {
                                                    if (
                                                        statusCheckin ===
                                                        CHECKIN_REALIZADO
                                                    ) {
                                                        console.log(
                                                            '1292 --- entre aca',
                                                            item.status,
                                                        )
                                                        if (
                                                            item.status !=
                                                                FORM_SCHEDULE_STATUS.COMPLETED &&
                                                            item.status !=
                                                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                                        )
                                                            navigateToForms(
                                                                item._id || index,
                                                            )
                                                    } else if (
                                                        statusCheckin ===
                                                            CHECKOUT_REALIZADO &&
                                                        item.type_form.type ===
                                                            FORM_TYPES.FORM_MODERACION &&
                                                        item.status ===
                                                            FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION
                                                    ) {
                                                        console.log(
                                                            '1295 --- entre aca',
                                                        )

                                                        navigateToForms(
                                                            item._id || index,
                                                        )
                                                    }
                                                }}
                                                isCompleted={item.complete}
                                                columns={4}
                                                form={item}
                                                checkout={
                                                    statusCheckin ===
                                                    CHECKOUT_REALIZADO
                                                }
                                            />
                                        )}
                                    </View>
                                )}
                                scrollEnabled={true}
                                ListFooterComponent={
                                    <View style={styles.marginHorizontal} />
                                }
                                // estimatedItemSize removed for TS compatibility
                            />
                        )}
                    </View>
                )}
            </>
        )
    }
    function renderPerfectStore() {
        let sectionTitle = languageFile.perfect_store
        let sectionDesc = languageFile.store_information

        return (
            <>
                {/* PERFECT STORE - Solo mostrar después de carga inicial */}
                {initialLoadComplete &&
                    !showPerfectStoreLoader &&
                    perfectStoreArrayMemoized.length > 0 && (
                        <>
                            <View
                                style={[
                                    styles.containerSection,
                                    { marginBottom: 8 },
                                ]}
                            >
                                <View>
                                    <Text style={[styles.textSection]}>
                                        {sectionTitle}
                                    </Text>
                                    <Text style={styles.textSectionDescription}>
                                        {sectionDesc}
                                    </Text>
                                </View>
                                <FlatList
                                    style={styles.flatList}
                                    keyExtractor={(item) => item?._id.toString()}
                                    data={perfectStoreArrayMemoized}
                                    horizontal={false}
                                    showsVerticalScrollIndicator={false}
                                    renderItem={({ item: item, index }) => (
                                        <StoreFormButtons
                                            name={item.title}
                                            image={item.icon}
                                            index={index}
                                            onClickItem={navigateToPF}
                                            isCompleted={false}
                                            columns={4}
                                        />
                                    )}
                                    numColumns={4}
                                    scrollEnabled={false}
                                    removeClippedSubviews={true}
                                    maxToRenderPerBatch={8}
                                    windowSize={5}
                                />
                            </View>
                        </>
                    )}
            </>
        )
    }
    function renderExecution() {
        let sectionTitle = languageFile.execution
        let sectionDesc = languageFile.perform_executions
        if (expoConfig.slug === 'savencia-one') {
            sectionTitle = 'Indicadores a relevar'
            sectionDesc =
                'Realiza el siguiente relevamiento para conocer el estado de la tienda.'
        }
        return (
            <>
                {/* EXECUTION - Solo mostrar después de carga inicial */}
                {initialLoadComplete &&
                    !showExecutionLoader &&
                    memorizedForms.length > 0 && (
                        <>
                            <View style={styles.containerSection}>
                                <View style={[styles.containerRow]}>
                                    <View>
                                        <View
                                            style={
                                                fontScale <= 1
                                                    ? styles.flexDirectionRow
                                                    : styles.flexDirectionColumn
                                            }
                                        >
                                            <Text style={styles.textSection}>
                                                {sectionTitle}
                                            </Text>

                                            {statusCheckin === CHECKOUT_REALIZADO ? (
                                                <View
                                                    style={[
                                                        fontScale <= 1
                                                            ? styles.marginLeft
                                                            : styles.marginLeftIcon,
                                                        styles.flexDirectionRow,
                                                    ]}
                                                >
                                                    <View style={styles.stamp}>
                                                        <Text
                                                            style={
                                                                styles.textCheckInOut
                                                            }
                                                        >
                                                            {
                                                                languageFile.check_out_done
                                                            }
                                                        </Text>
                                                    </View>
                                                </View>
                                            ) : (
                                                <View
                                                    style={[
                                                        styles.flexDirectionRow,
                                                        {
                                                            opacity:
                                                                statusCheckin ===
                                                                CHECKIN_REALIZADO
                                                                    ? 0
                                                                    : 1,
                                                        },
                                                    ]}
                                                >
                                                    <EvilIcons
                                                        name='lock'
                                                        size={iconSize * 1.2}
                                                        color={
                                                            theme.colors.colorLocked
                                                        }
                                                        style={[
                                                            styles.marginLeftExecution,
                                                            styles.marginRightExecution2,
                                                            styles.marginBottom,
                                                        ]}
                                                    />
                                                    <View style={styles.stamp}>
                                                        <Text
                                                            style={
                                                                styles.textRequires
                                                            }
                                                        >
                                                            {languageFile.requires}
                                                        </Text>
                                                        <Text
                                                            style={
                                                                styles.textCheckInOut
                                                            }
                                                        >
                                                            {languageFile.check_in}
                                                        </Text>
                                                    </View>
                                                </View>
                                            )}
                                        </View>
                                        <Text style={styles.textSectionDescription}>
                                            {sectionDesc}
                                        </Text>
                                    </View>
                                </View>
                                <FlatList
                                    style={styles.flatList}
                                    data={memorizedForms}
                                    horizontal={false}
                                    showsVerticalScrollIndicator={false}
                                    keyExtractor={(item) =>
                                        item._id.toString()
                                    }
                                    renderItem={({ item: item, index }) => (
                                        <StoreFormButtonsExecution
                                            name={item.name_form}
                                            image={item.icon}
                                            index={index}
                                            onClickItem={() => {
                                                if (
                                                    statusCheckin ===
                                                    CHECKIN_REALIZADO
                                                ) {
                                                    if (
                                                        item.type_form.type ===
                                                        FORM_TYPES.FORM_REDIRECT
                                                    ) {
                                                        if (
                                                            isConnected &&
                                                            hasInternet
                                                        ) {
                                                            let url = item?.link
                                                            if (url && url != '') {
                                                                const isValidUrl =
                                                                    url &&
                                                                    /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(
                                                                        url,
                                                                    )

                                                                if (!isValidUrl) {
                                                                    console.log(
                                                                        'URL inválida o no disponible:',
                                                                        url,
                                                                    )
                                                                    return
                                                                }
                                                                console.log(
                                                                    'Navegando a WebViewScreen',
                                                                    item?.link,
                                                                )
                                                                const params = {
                                                                    link: item?.link,
                                                                }
                                                                const actionButonSend =
                                                                    () => {
                                                                        //navigation.goBack()
                                                                    }

                                                                updateStatusForm(
                                                                    formsContext,
                                                                    scheduleID,
                                                                    item?._id,
                                                                    storeID,
                                                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                )

                                                                setReloadChange()

                                                                const sedForm =
                                                                    async () => {
                                                                        const registerUpdated =
                                                                            await schedulesServices.updateStatusFormAnswerSchedule(
                                                                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                                scheduleID,
                                                                                item?._id,
                                                                                storeID,
                                                                                'sin conexion',
                                                                                null,
                                                                                checkinID,
                                                                            )
                                                                        await schedulesServices.updateStatusSendForm(
                                                                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                            scheduleID,
                                                                            item?._id,
                                                                            storeID,
                                                                            'sin conexion',
                                                                            registerUpdated.updatedId,
                                                                        )
                                                                    }
                                                                sedForm()

                                                                // navigation.navigate('WebView', params as undefined)
                                                                openExternalLink(
                                                                    item?.link,
                                                                )
                                                            }
                                                        } else {
                                                            alert(
                                                                'Necesitas conexion para hecer este formulario ',
                                                            )
                                                        }
                                                    } else {
                                                        navigateToForms(
                                                            item._id ||
                                                                item.name_form ||
                                                                index,
                                                            item.name_form,
                                                        )
                                                    }
                                                } else {
                                                    if (
                                                        [
                                                            CHECKOUT_REALIZADO,
                                                            CHECKIN_PENDIENTE,
                                                        ].includes(statusCheckin) &&
                                                        item.type_form.type ===
                                                            FORM_TYPES.FORM_MODERACION &&
                                                        [
                                                            FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                                                            FORM_SCHEDULE_STATUS.REFUSED,
                                                        ].includes(item.status)
                                                    ) {
                                                        navigateToForms(
                                                            item._id ||
                                                                item.name_form ||
                                                                index,
                                                            item.name_form,
                                                        )
                                                    }
                                                }
                                            }}
                                            columns={4}
                                            form={item}
                                            formsContext={formsContext}
                                            reload={reload} // ✅ Pasamos reload como prop para forzar re-render
                                            // scoreObtained={item.scoreObtained}
                                            // data_form={{
                                            //     store_id: storeID,
                                            //     form_id: item._id,
                                            //     schedule_id: scheduleID,
                                            // }}
                                            statusCheckin={statusCheckin}
                                        />
                                    )}
                                    numColumns={4}
                                    scrollEnabled={false}
                                />
                            </View>
                        </>
                    )}
            </>
        )
    }
    function renderVouchers() {
        return (
            <>
                {vouchers.length > 0 && (
                    <View style={styles.containerSection}>
                        <RoundedTabs
                            tabs={tabs}
                            selectedIndex={selectedIndex}
                            colorLGStart={'white'}
                            colorLGEnd={'white'}
                            colorSelected={theme.colors.colorPrimary + '33'}
                            colorUnselected={theme.colors.colorPrimary + '14'}
                            onSelectedTab={(index) => {
                                setSelectedIndex(index)
                            }}
                            textColorOn={theme.colors.colorPrimary}
                            textColorOff={theme.colors.textPrimary}
                        />
                        {(() => {
                            switch (selectedIndex) {
                                case 0:
                                    return (
                                        <View>
                                            <Text
                                                style={styles.textSectionDescription}
                                            >
                                                {
                                                    'Vouchers disponibles para generar y compartir el QR de cada promoción.'
                                                }
                                            </Text>
                                            <StoreVouchersList
                                                vouchers={vouchers.filter(
                                                    (item) => item.status != 1,
                                                )}
                                                updateVoucher={updateVoucher}
                                            />
                                        </View>
                                    )
                                case 1:
                                    return (
                                        <View>
                                            <Text
                                                style={styles.textSectionDescription}
                                            >
                                                {
                                                    'Aquí verás tus vouchers canjeados, teniendo visibilidad de los canjes correctamente realizados.'
                                                }
                                            </Text>
                                            <StoreVouchersList
                                                vouchers={vouchers.filter(
                                                    (item) => item.status == 1,
                                                )}
                                                updateVoucher={updateVoucher}
                                            />
                                        </View>
                                    )
                                default:
                                    return (
                                        <Text>
                                            {languageFile.there_was_a_mistake}
                                        </Text>
                                    )
                            }
                        })()}
                    </View>
                )}
            </>
        )
    }

    const viewMap = {
        [STORE_VIEW_MAP.INDICATORS]: renderIndicators(),
        [STORE_VIEW_MAP.PERFECT_STORE]: renderPerfectStore(),
        [STORE_VIEW_MAP.EXECUTION]: renderExecution(),
        [STORE_VIEW_MAP.VOUCHERS]: renderVouchers(),
    }
    const originalOrder = [
        STORE_VIEW_MAP.INDICATORS,
        STORE_VIEW_MAP.PERFECT_STORE,
        STORE_VIEW_MAP.EXECUTION,
        STORE_VIEW_MAP.VOUCHERS,
    ]
    const viewOrder = storeDetailOrder || originalOrder

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <View style={styles.container}>
                    <ScrollView
                        showsVerticalScrollIndicator={false}
                        style={[
                            isIncidenceReport &&
                            status_store ==
                                STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE
                                ? { pointerEvents: 'none' }
                                : null,
                        ]}
                        nestedScrollEnabled={true}
                    >
                        {store && (
                            <LinearGradient
                                style={[
                                    styles.containerStoreData,
                                    { marginBottom: 20 },
                                ]}
                                colors={[
                                    theme.colors.linearGradientStart,
                                    theme.colors.linearGradientEnd,
                                ]}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0 }}
                            >
                                <View style={styles.containerNameStore}>
                                    {/* <Image
                                            style={[styles.storeImage, { width: iconSize, height: iconSize }]}
                                            source={require('../../../assets/stores/store.png')}
                                        /> */}
                                    <MaterialCommunityIcons
                                        name='store'
                                        size={24}
                                        color={'white'}
                                        style={[
                                            styles.marginRightExecution,
                                            styles.marginBottom1,
                                        ]}
                                    />
                                    {/* <Feather name='map-pin' size={iconSize} color={'black'} style={[styles.marginRightExecution, styles.marginBottom]}/> */}
                                    <Text
                                        numberOfLines={2}
                                        style={styles.textNameStore}
                                    >
                                        {store.name ?? ''}
                                    </Text>
                                </View>
                                {/* <Text selectable>{store._id}</Text> */}
                                <View style={styles.containerDataStore}>
                                    <Text style={styles.storecode}>
                                        {store.code ? store.code + '  |  ' : ''}
                                        {store.cluster
                                            ? store.cluster + '  |  '
                                            : ''}
                                        {potencial && potencial != ''
                                            ? potencial + '  |  '
                                            : ''}
                                        {frequency && frequency != ''
                                            ? frequency + '  |  '
                                            : ''}
                                        {topStore && topStore != ''
                                            ? topStore + '  |  '
                                            : ''}

                                        <Feather
                                            name='map-pin'
                                            size={13}
                                            color={'white'}
                                        />
                                        {store.distance
                                            ? ' ' + store.distance + '  '
                                            : ' '}
                                    </Text>

                                    {/* {store.additional && <StoreAdditionalView additional={store.additional} />}

                                        {store.cluster && <Text style={[styles.textInfoStore]}> | {store.cluster}</Text>} */}

                                    {/* {store.distance && store.cluster && store.cluster.length < 13 && fontScale <= 1 && (
                                            <View style={styles.containerDataStoreBis}>
                                                <Text style={styles.colorWhite}> | </Text>
                                                <Feather name='map-pin' size={13} color={'white'} />
                                                <Text numberOfLines={2} style={[styles.colorWhite, styles.marginStart]}>{store.distance}</Text>
                                            </View>
                                        )} */}
                                </View>

                                <TouchableOpacity
                                    onPress={openMap}
                                    style={[
                                        styles.containerRow,
                                        { marginHorizontal: 11 },
                                    ]}
                                >
                                    {/* <Feather name='navigation' size={iconSize} color={'white'} style={[styles.marginRight, styles.marginTop2]} /> */}
                                    <Text style={styles.textAddressStoreWithGoTo}>
                                        {store.address ?? ''}
                                    </Text>
                                </TouchableOpacity>
                                {(store.distance &&
                                    store.cluster &&
                                    store.cluster.length >= 13) ||
                                    (fontScale > 1 && (
                                        <View style={styles.containerDistance}>
                                            <Feather
                                                name='map-pin'
                                                size={iconSize}
                                                color={'white'}
                                            />
                                            <Text
                                                style={[
                                                    styles.colorWhite,
                                                    styles.marginStart,
                                                ]}
                                            >
                                                {store.distance}
                                            </Text>
                                        </View>
                                    ))}

                                {RenderIndicence}
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        marginTop: 15,
                                    }}
                                >
                                    {renderButtonStore()}
                                    {statusCheckin == CHECKIN_PENDIENTE &&
                                        RenderNotifyIndicence}
                                </View>
                            </LinearGradient>
                        )}

                        {viewOrder.map((key) => {
                            const Component = viewMap[key]
                            return (
                                <React.Fragment key={key}>
                                    {Component}
                                </React.Fragment>
                            )
                        })}
                    </ScrollView>
                </View>
            )}
        </>
    )
})

export const StoreAdditionalView = ({
    additional,
}: {
    additional: StoreAdditionalInfo[]
}) => {
    return (
        <View style={styles.flexDirectionRow}>
            {additional.map((item, index) => {
                if (item.label) {
                    switch (item.label) {
                        case 'segment':
                        case 'route':
                            return (
                                <Text key={item.id} style={styles.textInfoStore}>
                                    , {item.value}
                                </Text>
                            )
                        default:
                            return null
                    }
                }
            })}
        </View>
    )
}
export const PerfectStoreButtons = React.memo(
    ({ perfectStore }: { perfectStore: PerfectStoreModel }) => {
        return (
            <View>
                {/* <TouchableOpacity style={styles.perfectStoreButton} onPress={() => {}}> */}
                <TouchableOpacity
                    style={styles.perfectStoreButton}
                    onPress={() => {}}
                >
                    <Image
                        source={{
                            uri: perfectStore.icon
                                ? perfectStore.icon
                                : placeholderGeneral,
                        }}
                        style={styles.iconImage}
                        resizeMode='contain'
                    />
                    <Text style={styles.textName}>{perfectStore.title}</Text>
                </TouchableOpacity>
            </View>
        )
    },
)

interface StoreFormButtonsIndicatorsProps {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    isCompleted: boolean
    columns: number
    form: FormProps
    checkout: boolean
}

export const StoreFormButtonsIndicators = React.memo(
    ({
        name,
        image,
        index,
        onClickItem,
        isCompleted,
        columns,
        form,
        checkout,
    }: StoreFormButtonsIndicatorsProps) => {
        const { languageFile } = getLanguage()
        const { formsContext, reload } = useFormContext()

        const [statusForm, setStatusForm] = useState<statusFormProps>({
            status: null,
            repeat: null,
            score: null,
            progress: null,
            progress_questions_yes_na: null,
            mandatory: null,
            featured: null,
        })

        useEffect(() => {
            const indexForm = formsContext.findIndex(
                (formContext) => formContext._id === form._id,
            )

            //  console.log('684 ----- formsContext[indexForm] : ', formsContext[indexForm].progress_questions_yes_na)

            if (indexForm !== -1) {
                setStatusForm({
                    repeat: formsContext[indexForm].repeat,
                    status: formsContext[indexForm].status,
                    score: formsContext[indexForm].scoreObtained,
                    progress: formsContext[indexForm].progress,
                    progress_questions_yes_na:
                        formsContext[indexForm].progress_questions_yes_na,
                    mandatory: formsContext[indexForm].mandatory,
                    featured: formsContext[indexForm].featured,
                })
            }
        }, [reload, form])

        const getGradientColors = (index) => {
            const gradientIndex = index % 5
            const isInverted = Math.floor(index / 5) % 2 === 1
            const gradientStartKey = `linearGradientStart0${gradientIndex}`
            const gradientEndKey = `linearGradientEnd0${gradientIndex}`

            // console.log(`Index: ${index}, Gradient Index: ${gradientIndex}, Is Inverted: ${isInverted}`)
            // console.log(`Start Color Key: ${gradientStartKey}, End Color Key: ${gradientEndKey}`)
            // console.log(`Start Color: ${theme.colors[gradientStartKey]}, End Color: ${theme.colors[gradientEndKey]}`)

            if (isInverted) {
                return [theme.colors[gradientEndKey], theme.colors[gradientStartKey]]
            } else {
                return [theme.colors[gradientStartKey], theme.colors[gradientEndKey]]
            }
        }

        const gradientColors = getGradientColors(index) as unknown as readonly [
            string,
            string,
        ]

        const renderItem = ({ statusForm }) => {
            let view = -1
            if (
                statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED &&
                statusForm.progress
            ) {
                view = 0
            } else if (
                statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED &&
                !statusForm.progress
            ) {
                view = 1
            } else if (
                statusForm.status === FORM_SCHEDULE_STATUS.PENDING &&
                !checkout
            ) {
                view = 2
            } else if (
                statusForm.status === FORM_SCHEDULE_STATUS.PENDING &&
                checkout
            ) {
                view = 3
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.IN_PROGRESS) {
                view = 2
            } else if (
                statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION &&
                statusForm.progress
            ) {
                view = 0
            }
            const render_progres = statusForm.progress_questions_yes_na
                ? `${Math.round(statusForm.progress_questions_yes_na)}%`
                : '-'

            switch (view) {
                case 0:
                    return (
                        // <Progress.Circle
                        //     size={70}
                        //     progress={statusForm.progress_questions_yes_na / 100}
                        //     showsText={true}
                        //     // formatText={(progress) => `${Math.round(statusForm.progress_questions_yes_na / 100)}%`}
                        //     formatText={(progress) => `${render_progres}`}
                        //     textStyle={styles.textProgressCircle}
                        //     thickness={7}
                        //     color={'white'}
                        //     unfilledColor={theme.colors.colorTertiary}
                        //     borderWidth={0}
                        //     strokeCap='round'
                        // />
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={statusForm.progress_questions_yes_na}
                            tintColor={'white'}
                            backgroundColor={theme.colors.colorTertiary}
                            padding={0}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Text
                                    style={[
                                        styles.textProgressCircle,
                                        { color: 'white' },
                                    ]}
                                >
                                    {render_progres}
                                </Text>
                            )}
                        </AnimatedCircularProgress>
                    )

                case 1:
                    return (
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={0}
                            tintColor={'white'}
                            backgroundColor={theme.colors.colorTertiary}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Image
                                    style={{ width: 18, height: 18, marginTop: -10 }}
                                    source={require('../../../assets/form_check.png')}
                                />
                            )}
                        </AnimatedCircularProgress>
                    )

                case 2:
                    return (
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={0}
                            tintColor={'white'}
                            backgroundColor={theme.colors.colorTertiary}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Image
                                    style={{ width: 18, height: 18, marginTop: -10 }}
                                    source={require('../../../assets/form_wrong.png')}
                                />
                            )}
                        </AnimatedCircularProgress>
                    )

                case 3:
                    return (
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={0}
                            tintColor={'white'}
                            backgroundColor={theme.colors.colorTertiary}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Image
                                    style={{ width: 18, height: 18, marginTop: -10 }}
                                    source={require('../../../assets/form_minus.png')}
                                />
                            )}
                        </AnimatedCircularProgress>
                    )
                default:
                    return (
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={0}
                            tintColor={'white'}
                            backgroundColor={theme.colors.colorTertiary}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Image
                                    style={{ width: 18, height: 18, marginTop: -10 }}
                                    source={require('../../../assets/form_minus.png')}
                                />
                            )}
                        </AnimatedCircularProgress>
                    )
            }
        }

        const handleClickSet = (status: number, repeat: boolean) => {
            // console.log('1112 ---- 🚀 ~ file: StoreDetail.tsx:595 ~ handleClickSet ~ repeat - status:', repeat, status)
            // console.log('1113 ----- status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat: ', status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat)
            if (status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat) {
                return () => {}
            } else {
                // console.log('1115 ----------- onClickItem: ')
                return onClickItem(index)
            }
        }
        const expoConfig = Constants.expoConfig || { slug: '' }

        const showLR = expoConfig.slug === 'savencia-one'

        return (
            <>
                {statusForm.mandatory === true || statusForm.featured === true ? (
                    <View style={[styles.containerItemsIndicators]}>
                        <TouchableOpacity
                            onPress={() =>
                                handleClickSet(statusForm.status, statusForm.repeat)
                            }
                        >
                            <LinearGradient
                                style={[styles.containerIndicator, { height: 135 }]}
                                colors={gradientColors}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0.5 }}
                            >
                                <Text
                                    style={[styles.textIndicatorName]}
                                    numberOfLines={1}
                                >
                                    {name}
                                </Text>
                                {/* <Text style={styles.textIndicatorData}>98°</Text> */}
                                <View
                                    style={[
                                        styles.containerProgress,
                                        { marginBottom: 5 },
                                    ]}
                                >
                                    {/* PROGRESS A MODIFICAR */}
                                    {renderItem({ statusForm })}
                                </View>

                                <Text
                                    style={{
                                        opacity: showLR ? 1 : 0,
                                        fontSize: 11,
                                        color: 'white',
                                        marginBottom: 0,
                                        marginTop: 2,
                                        textAlign: 'center',
                                    }}
                                >
                                    {'Variación LR'}
                                    {'\n'}
                                    <Text
                                        style={{
                                            color: 'white',
                                            fontWeight: '700',
                                            fontSize: 13,
                                        }}
                                        numberOfLines={1}
                                    >
                                        {'-'}
                                    </Text>
                                </Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                ) : (
                    <></>
                )}
            </>
        )
    },
)

export const StoreFormButtons = React.memo(
    ({
        name,
        image,
        index,
        onClickItem,
        isCompleted,
        columns,
    }: {
        name: string
        image: string
        index: number
        onClickItem: (index: number) => void
        isCompleted: boolean
        columns: number
    }) => {
        // const imagePs = 'https://resources-one.s3.us-east-2.amazonaws.com/assets/ejecucion_one/calidad.png'
        // const imagePs = useImageLoader(image, PATH_ASSETS)

        const { image: imagePs, loading } = useImageLoader(image, PATH_ASSETS)
        const numberOfLines = name.includes(' ') ? 2 : 1
        return (
            <View style={styles.containerItemsPS}>
                <TouchableOpacity
                    style={[styles.alignCenter, { width: (width - 100) / columns }]}
                    onPress={() => onClickItem(index)}
                >
                    {loading ? (
                        <Loader />
                    ) : (
                        <View
                            style={{
                                backgroundColor:
                                    theme.colors.storeFormButtonBackground,
                                borderRadius: 50,
                                width: 62,
                                height: 62,
                            }}
                        >
                            <Image
                                source={{ uri: imagePs }}
                                style={[styles.iconImage, { margin: 15 }]}
                                resizeMode='contain'
                            />
                        </View>
                    )}
                    <Text
                        style={styles.textName}
                        numberOfLines={numberOfLines}
                        ellipsizeMode='tail'
                    >
                        {name}
                    </Text>
                </TouchableOpacity>
            </View>
        )
    },
)

interface StoreFormButtonsExecutionProps {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    // isCompleted: boolean
    columns: number
    form: FormsModel
    // data_form: { store_id: string; form_id: string; schedule_id: string }
    // scoreObtained?: number
    statusCheckin?: number
    formsContext?: FormProps[]
    reload?: number // ✅ Añadido para forzar re-render cuando cambie
}
interface statusFormProps {
    status: number | null
    repeat: boolean | null
    score?: number | null
    progress: boolean | null | number
    progress_questions_yes_na: number | null
    mandatory?: boolean | null
    featured?: boolean | null
}

export const StoreFormButtonsExecution = React.memo(
    ({
        name,
        image,
        index,
        onClickItem,
        columns,
        form,
        statusCheckin,
        formsContext,
        reload,
    }: StoreFormButtonsExecutionProps) => {
        // console.log('me vuelvo a renderizar ? StoreFormButtonsExecution => ', name)
        const { languageFile } = getLanguage()
        // ✅ Ya no necesitamos obtener reload del contexto, lo recibimos como prop

        const [statusForm, setStatusForm] = useState<statusFormProps>({
            status: null,
            repeat: null,
            score: null,
            progress: null,
            progress_questions_yes_na: null,
        })

        const { image: imageForm, loading } = useImageLoader(image, PATH_ASSETS)

        const STATUS_COMPLETE = statusForm.progress
            ? statusForm.progress_questions_yes_na != null
                ? Math.round(statusForm.progress_questions_yes_na) + '%'
                : '-'
            : languageFile.complete_mayus

        // const STATUS_COMPLETE = statusForm.progress ? statusForm.progress_questions_yes_na + '%' : languageFile.complete_mayus
        const STATUS_IN_PROGRESS = languageFile.in_progress_mayus
        const STATUS_PENDING_CONEXION = statusForm.progress
            ? statusForm.progress_questions_yes_na != null
                ? Math.round(statusForm.progress_questions_yes_na) + '%'
                : '-'
            : languageFile.complete_mayus //'SYNC.'
        const STATUS_BLOCKED = languageFile.locked_mayus
        const STATUS_PENDING = languageFile.pending_mayus
        const STATUS_PENDING_MODERACION = 'EN REVISIÓN'
        const STATUS_REFUSED = 'RECHAZADO'

        // useEffect(() => {
        //     setStatusForm({
        //         status: null,
        //         repeat: null,
        //         score: null,
        //         progress: null,
        //         progress_questions_yes_na: null,
        //     })

        //     // if (!statusForm.status) {
        //     //     setStatusForm({ status: null, repeat: null, score: null, progress: null, progress_questions_yes_na: null });
        //     // }
        // }, [])

        useEffect(() => {
            // console.log(
            //     `🔄 [StoreFormButtonsExecution ${name}] useEffect triggered - reload:`,
            //     reload,
            //     'form._id:',
            //     form._id,
            // )

            const indexForm = formsContext.findIndex(
                (formContext) => formContext._id === form._id,
            )
            if (indexForm !== -1) {
                const newStatus = {
                    repeat: formsContext[indexForm].repeat,
                    status: formsContext[indexForm].status,
                    score: formsContext[indexForm].scoreObtained,
                    progress: formsContext[indexForm].progress,
                    progress_questions_yes_na:
                        formsContext[indexForm].progress_questions_yes_na,
                }
                // console.log(
                //     `📊 [${name}] Status actual:`,
                //     statusForm.status,
                //     'Nuevo status:',
                //     newStatus.status,
                //     'reload:',
                //     reload,
                // )

                // ✅ SIEMPRE actualizar cuando cambie reload, sin importar si el status es igual
                // Esto fuerza el re-render visual después del check-in
                setStatusForm(newStatus)
                // console.log(
                //     `✅ [${name}] Status form actualizado a ${newStatus.status}, reloadKey incrementado`,
                // )
            }
        }, [form, reload, formsContext])

        const statusText = (status: number): string => {
            const statusMap: { [key: number]: string } = {
                [FORM_SCHEDULE_STATUS.COMPLETED]: STATUS_COMPLETE,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: STATUS_IN_PROGRESS,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: STATUS_COMPLETE,
                [FORM_SCHEDULE_STATUS.BLOCKED]: STATUS_BLOCKED,
                [FORM_SCHEDULE_STATUS.PENDING]: STATUS_PENDING,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: STATUS_PENDING_CONEXION,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]:
                    STATUS_PENDING_MODERACION,
                [FORM_SCHEDULE_STATUS.REFUSED]: STATUS_REFUSED,
            }

            return statusMap[status] || STATUS_BLOCKED
        }

        const styleSet = (status: number, repeat: boolean) => {
            // console.log('640 ------- status: ', status)
            // console.log('641 ------- repeat: ', repeat)
            if (status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat) {
                return {
                    flexGrow: 0,
                    opacity: 1,
                }
            } else if (status === FORM_SCHEDULE_STATUS.BLOCKED) {
                return {
                    flexGrow: 0,
                    opacity: 0.5,
                }
            } else {
                return null
            }
        }

        const handleClickSet = (status: number, repeat: boolean) => {
            // console.log('1256 ---- 🚀 ~ file: StoreDetail.tsx:595 ~ handleClickSet ~ repeat - status:', repeat, status)
            // console.log('1257 ----- status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat: ', status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat)
            const validate_status = [
                FORM_SCHEDULE_STATUS.COMPLETED,
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
            ]
            const validateTypeForm = [FORM_TYPES.FORM_REDIRECT]
            if (
                validate_status.includes(status) &&
                !repeat &&
                !validateTypeForm.includes(form.type_form.type)
            ) {
                // No hacer nada si el formulario está completado y no es repetible
                console.log(
                    `🔒 [${name}] Formulario bloqueado - status: ${status}, repeat: ${repeat}`,
                )
            } else {
                // ✅ Ejecutar onClickItem directamente (no retornar su resultado)
                console.log(
                    `✅ [${name}] Ejecutando onClickItem - status: ${status}`,
                )
                onClickItem(index)
            }
        }

        // lista de formularios que muestran %
        const formsWithPercentage = (statusForm) => {
            // console.log('STATUS FORM ==>', statusForm)
            if (
                statusForm?.progress === true &&
                statusForm?.progress_questions_yes_na != null
            ) {
                return true
            }
            return false
        }

        const statusToColorMap = useMemo(
            () => ({
                [FORM_SCHEDULE_STATUS.COMPLETED]: formsWithPercentage(statusForm)
                    ? theme.colors.colorApproved
                    : 'transparent',
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]:
                    [CHECKIN_REALIZADO, CHECKOUT_REALIZADO].includes(
                        statusCheckin,
                    ) || !formsWithPercentage(statusForm)
                        ? theme.colors.alert
                        : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                default: theme.colors.colorLocked,
            }),
            [statusForm.status],
        )

        // color del progress circle
        const colorProgressCircle =
            statusToColorMap[statusForm.status] || statusToColorMap.default

        // color del progress circle sobrante
        const unfilledColorProgressCircle =
            (statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED &&
                !formsWithPercentage(statusForm)) ||
            (statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION &&
                !formsWithPercentage(statusForm))
                ? 'transparent'
                : theme.colors.lightGray

        const iconTintColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: !formsWithPercentage(statusForm)
                    ? theme.colors.colorApproved
                    : 'transparent',
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: !formsWithPercentage(
                    statusForm,
                )
                    ? statusCheckin !== CHECKIN_REALIZADO
                        ? theme.colors.colorLocked
                        : theme.colors.darkGray
                    : 'transparent',
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]:
                    theme.colors.colorPending,
            }[statusForm.status] || theme.colors.colorLocked

        const textColor =
            {
                [FORM_SCHEDULE_STATUS.BLOCKED]: theme.colors.colorLocked,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]:
                    theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.COMPLETED]:
                    statusText(Math.round(statusForm.status)) === '100%'
                        ? theme.colors.colorApproved
                        : theme.colors.darkGray,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]:
                    statusText(Math.round(statusForm.status)) === '100%'
                        ? theme.colors.textPrimary
                        : theme.colors.alert,
            }[statusForm.status] || theme.colors.colorCancelled

        // color del fondo del texto del status
        const labelBackgroundColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: [
                    CHECKIN_REALIZADO,
                    CHECKOUT_REALIZADO,
                ].includes(statusCheckin)
                    ? theme.colors.alert
                    : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: 'transparent',
                // }[statusForm.status] || 'transparent'
            }[statusForm.status] || 'transparent'

        const labelBorderColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: [
                    CHECKIN_REALIZADO,
                    CHECKOUT_REALIZADO,
                ].includes(statusCheckin)
                    ? theme.colors.alert
                    : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]:
                    theme.colors.colorPending,
            }[statusForm.status] || theme.colors.colorLocked

        const labelTextColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: 'white',
                [FORM_SCHEDULE_STATUS.BLOCKED]: theme.colors.colorLocked,
                [FORM_SCHEDULE_STATUS.PENDING]: 'white',
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]:
                    statusCheckin === 1 ? theme.colors.textPrimary : 'white',
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]:
                    theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: 'white',
            }[statusForm.status] || theme.colors.colorLocked
        const numberOfLines = name.includes(' ') ? 2 : 1

        return (
            <View
                style={[
                    styles.containerItemsExecution,
                    styleSet(statusForm.status, statusForm.repeat),
                ]}
            >
                <TouchableOpacity
                    // style={[styles.alignCenter,  {flex: 1, width: (width - 92) / columns }]}
                    style={[styles.alignCenter, { flex: 1 }]}
                    disabled={false}
                    onPress={() =>
                        handleClickSet(statusForm.status, statusForm.repeat)
                    }
                >
                    <View style={[styles.containerProgress, { height: 60 }]}>
                        {/* //Tenes que saber si va o no el progress si va progress esto de abajo va  sino va null */}
                        {(statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED ||
                            statusForm.status ===
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION) &&
                            statusForm.progress_questions_yes_na > 0 && (
                                <Progress.Circle
                                    size={60}
                                    progress={
                                        statusForm.progress_questions_yes_na / 100
                                    }
                                    showsText={false}
                                    thickness={3}
                                    color={colorProgressCircle}
                                    unfilledColor={unfilledColorProgressCircle}
                                    borderWidth={0.1}
                                    borderColor={theme.colors.modalBackground}
                                    strokeCap='round'
                                />
                            )}
                        {/*statusForm.status != FORM_SCHEDULE_STATUS.COMPLETED && statusForm.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION && (*/}
                        {loading ? (
                            <Loader />
                        ) : formsWithPercentage(statusForm) ? (
                            // <Image source={{ uri: null }} style={[styles.iconImageExecution, { tintColor: iconTintColor }]} resizeMode='contain' />
                            <>
                                {statusForm.status !=
                                    FORM_SCHEDULE_STATUS.COMPLETED &&
                                    statusForm.status !=
                                        FORM_SCHEDULE_STATUS.PENDING_CONNECTION && (
                                        <View
                                            style={{
                                                backgroundColor:
                                                    theme.colors
                                                        .storeFormButtonBackground,
                                                borderRadius: 40,
                                                position: 'absolute',
                                            }}
                                        >
                                            <Image
                                                source={{ uri: imageForm }}
                                                style={[
                                                    styles.iconImageExecution,
                                                    { tintColor: iconTintColor },
                                                ]}
                                                resizeMode='contain'
                                            />
                                        </View>
                                    )}
                            </>
                        ) : (
                            <View
                                style={{
                                    backgroundColor:
                                        theme.colors.storeFormButtonBackground,
                                    borderRadius: 40,
                                    position: 'absolute',
                                }}
                            >
                                <Image
                                    source={{ uri: imageForm }}
                                    style={[
                                        styles.iconImageExecution,
                                        { tintColor: iconTintColor },
                                    ]}
                                    resizeMode='contain'
                                />
                            </View>
                        )}
                        {/*)}*/}
                        {(statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED ||
                            statusForm.status ===
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION) && (
                            <Text
                                style={[styles.percentage, { color: textColor }]}
                                numberOfLines={1}
                            >
                                {statusText(Math.round(statusForm.status)) ===
                                languageFile.complete_mayus
                                    ? ''
                                    : statusText(Math.round(statusForm.status))}
                            </Text>
                        )}
                    </View>

                    <View style={styles.containerStatus}>
                        <View
                            style={[
                                styles.statusFormList,
                                {
                                    backgroundColor: labelBackgroundColor,
                                    borderColor: labelBorderColor,
                                },
                            ]}
                        >
                            <Text
                                style={[
                                    styles.textStatus,
                                    { color: labelTextColor },
                                ]}
                                numberOfLines={1}
                            >
                                {statusForm.status ===
                                    FORM_SCHEDULE_STATUS.COMPLETED ||
                                statusForm.status ===
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                    ? languageFile.complete_mayus
                                    : statusText(Math.round(statusForm.status))}
                            </Text>
                        </View>
                    </View>
                    <Text
                        style={[
                            styles.textNameExecution,
                            {
                                width: 80,
                                textAlign: 'center',
                                alignContent: 'center',
                            },
                        ]}
                        numberOfLines={numberOfLines}
                        ellipsizeMode='tail'
                    >
                        {name}
                    </Text>
                </TouchableOpacity>
            </View>
        )
    },
)

const GotoForm = ({
    data,
    closeBottomSheet,
    navigateToForms,
    indexForm,
    title,
    button = false,
    checkOut = () => {},
}) => {
    const { languageFile } = getLanguage()

    const [enableButton, setEnableButton] = useState(false)

    const navigateForm = () => {
        navigateToForms(indexForm)
        closeBottomSheet(true)
    }

    const handleConfirm = async () => {
        setEnableButton(true)
        let Checkout = await checkOut()
        console.log('2219 --- CHECKOUT')

        closeBottomSheet(true) // Cerrar el BottomSheet si es necesario
        setEnableButton(false) // Habilitar el botón después de 10 segundos

        //closeBottomSheet(true)
        // setEnableButton(false)
    }
    const parts = data.message.split(':')
    const beforeColon = parts[0]
    const afterColon = parts[1]

    return (
        <View style={styles.contentContainer}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.messageContainer}>
                <View>
                    <Image
                        style={styles.imageAsset}
                        source={require('../../../assets/stores/checkOutLocked.png')}
                        resizeMode='contain'
                    />
                </View>
                {!button ? (
                    <View>
                        <Text style={styles.titleText}>{title}</Text>
                        <Text
                            style={[
                                styles.descriptionText,
                                { paddingHorizontal: 12 },
                            ]}
                        >
                            {data.message}
                        </Text>
                    </View>
                ) : (
                    <View>
                        <Text style={styles.titleText}>
                            {title && title != ''
                                ? title
                                : languageFile.uncompleted_forms}
                        </Text>
                        <Text style={styles.descriptionText}>{data.message}</Text>
                    </View>
                )}
            </View>

            <View style={styles.spacer} />

            <View style={styles.containerButton}>
                {!button && (
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor: theme.colors.colorPrimary,
                            },
                        ]}
                        onPress={() => navigateForm()}
                    >
                        <Text style={styles.textButton}>
                            {languageFile.go_to_survey}
                        </Text>
                    </TouchableOpacity>
                )}

                {button && (
                    <View>
                        <TouchableOpacity
                            style={[
                                styles.button,
                                {
                                    backgroundColor: enableButton
                                        ? theme.colors.colorLocked
                                        : theme.colors.colorPrimary,
                                },
                            ]}
                            onPress={() => handleConfirm()}
                            disabled={enableButton}
                        >
                            <Text style={styles.textButton}>
                                {languageFile.check_out}
                            </Text>
                        </TouchableOpacity>

                        <TouchableOpacity
                            style={styles.buttonCancel}
                            onPress={() => navigateForm()}
                        >
                            <Text style={styles.textCancel}>
                                {languageFile.go_to_survey}
                            </Text>
                        </TouchableOpacity>
                    </View>
                )}
            </View>
        </View>
    )
}
